<template>
  <!-- 导出国家级报告 -->
  <div class="analysisReport">
    <!-- <el-button type="primary" class="export" @click="downloadPage('pdfPrint',header.zykNum,header.zykName)">导出</el-button> -->
    <!-- <el-button class="export" type="primary" size="small" @click="toImage">生成PDF</el-button> -->
    <div class="analysisReport_box" id="pdfPrint">
      <span v-show="false">这是completeNum的值：{{ completeMathodNum }}</span>
      <input
        v-show="false"
        v-model="completeMathodNum"
        id="completeMathodNum"
      />
      <!-- PDF  首页 -->
      <div
        class="HomePage"
        style="
          height: 2740px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        "
      >
        <div id="image"></div>
        <div id="PdfTitle">
          <p id="FristTitle">国家职业教育智慧教育平台专业与课程服务中心</p>
          <div>
            <p id="SecondTitle" v-if="reportType == 1">
              建设及应用监测年度分析报告
            </p>
            <p id="SecondTitle" v-if="reportType == 2">
              建设及应用监测半年度分析报告
            </p>
            <p class="ThrendTitle" v-if="reportType == 1">
              （{{ nowYear }}{{ detailYearWord }}）
            </p>
            <p class="ThrendTitle" v-if="reportType == 2">
              （{{ nowYear }}{{ detailYearWord }}）
            </p>
          </div>
          <p id="FourTitle">
            运行分析起止时间：{{ startDay }} 至
            {{ endDay }}
          </p>
        </div>
        <div id="foot">
          <div class="footBox">
            <p>国家职业教育智慧教育平台专业与课程服务中心监测平台项目组</p>
            <p>广东轻工职业技术学院产教融合大数据研究所</p>
            <p>
              <span v-if="nowMonth != '12'">{{ nowYear }}年</span>
              <span v-else>{{ +nowYear + 1 }}年</span>
              <span v-if="nowMonth != '12'">{{ +nowMonth + 1 }}</span
              ><span v-else>1</span> 月 10 日
            </p>
          </div>
        </div>
      </div>

      <!-- 目录 -->
      <div class="catalogue page-box">
        <div class="title">
          <p style="font-size: 60px; font-weight: 700">
            目&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录
          </p>
        </div>
        <h5>1. 专业与课程服务中心监测总体分析<span class="dot"></span>1</h5>
        <h5 class="Second_text">
          1.1 总体建设及应用分析<span class="dot"></span>1
        </h5>
        <div class="Thred_text">
          <h5>1.1.1 用户建设及应用情况<span class="dot"></span>1</h5>
          <h5>1.1.2 课程建设及应用情况<span class="dot"></span>2</h5>
          <h5>1.1.3 资源建设及应用情况<span class="dot"></span>3</h5>
        </div>
        <h5 class="Second_text">
          1.2 各省建设及应用情况分析<span class="dot"></span>4
        </h5>
        <div class="Thred_text">
          <h5>1.2.1 各省用户建设及应用情况<span class="dot"></span>4</h5>
          <h5>1.2.2 各省课程建设及应用情况<span class="dot"></span>5</h5>
          <h5>1.2.3 各省资源建设及应用情况<span class="dot"></span>5</h5>
        </div>
        <h5 class="Second_text">
          1.3 {{ nowYear }}{{ detailYearWord }}运行监测总体分析<span
            class="dot"
          ></span
          >6
        </h5>
        <div class="Thred_text">
          <h5>
            1.3.1 {{ nowYear }}{{ detailYearWord }}用户建设及应用总体情况<span
              class="dot"
            ></span
            >6
          </h5>
          <h5>
            1.3.2 {{ nowYear }}{{ detailYearWord }}课程建设及应用总体情况<span
              class="dot"
            ></span
            >7
          </h5>
          <h5>
            1.3.3 {{ nowYear }}{{ detailYearWord }}资源建设及应用总体情况<span
              class="dot"
            ></span
            >8
          </h5>
        </div>
        <h5>
          2.职业教育专业教学资源库运行监测情况分析<span class="dot"></span>9
        </h5>
        <h5 class="Second_text">
          2.1 {{ twoGetCountry.zykCountryNum }}个国家级资源库建设及应用情况分析<span class="dot"></span>9
        </h5>
        <div class="Thred_text">
          <h5>2.1.1 用户建设及应用情况<span class="dot"></span>9</h5>
          <h5>2.1.2 课程建设及应用情况<span class="dot"></span>10</h5>
          <h5>2.1.3 资源建设及应用情况<span class="dot"></span>10</h5>
          <h5>2.1.4 按专业大类汇总统计分析<span class="dot"></span>11</h5>
          <h5>
            2.1.5 各省国家级资源库建设及应用情况<span class="dot"></span>20
          </h5>
          <h5>
            2.1.6 国家级资源库{{ nowYear
            }}{{ detailYearWord }}建设及应用情况<span class="dot"></span>23
          </h5>
          <h5>
            2.1.7 国家级资源库建设及应用情况排名<span class="dot"></span>27
          </h5>
        </div>
      </div>

      <div class="catalogue page-box">
        <div v-if="reportType == 1">
          <h5 class="Second_text">
            2.2 国家及省市校级专业教学资源库运行监测情况分析<span
              class="dot"
            ></span
            >30
          </h5>
          <div class="Thred_text">
            <h5>2.2.1 用户建设及应用情况<span class="dot"></span>30</h5>
            <h5>2.2.2 课程建设及应用情况<span class="dot"></span>31</h5>
            <h5>2.2.3 资源建设及应用情况<span class="dot"></span>31</h5>
            <h5>2.2.4 各省资源库建设及应用情况<span class="dot"></span>32</h5>
            <h5>
              2.2.5 {{ nowYear
              }}{{ detailYearWord }}资源库总体建设及应用情况<span
                class="dot"
              ></span
              >35
            </h5>
            <h5>2.2.6 资源库建设及应用情况排名<span class="dot"></span>39</h5>
          </div>
          <h5>3. 在线精品课程运行监测情况分析<span class="dot"></span>41</h5>
          <h5 class="Second_text">
            3.1 各省建设课程情况<span class="dot"></span>41
          </h5>
          <h5 class="Second_text">
            3.2 课程归属专业大类情况<span class="dot"></span>41
          </h5>
          <h5 class="Second_text">
            3.3 在线精品课访问情况<span class="dot"></span>42
          </h5>
          <h5 class="Second_text">
            3.4 在线精品课开课情况<span class="dot"></span>42
          </h5>
          <h5 class="Second_text">
            3.5 在线精品课程选课情况<span class="dot"></span>43
          </h5>
          <h5>4. 视频公开课运行监测情况分析<span class="dot"></span>43</h5>
          <h5 class="Second_text">
            4.1 各省视频公开课建设情况<span class="dot"></span>43
          </h5>
          <h5 class="Second_text">
            4.2 视频公开课访问情况<span class="dot"></span>44
          </h5>
          <h5 class="Second_text">
            4.3 视频公开课选课情况<span class="dot"></span>44
          </h5>
        </div>
        <div v-else>
          <h5 class="Second_text">
            2.2 国家及省市校级专业教学资源库运行监测情况分析<span
              class="dot"
            ></span
            >29
          </h5>
          <div class="Thred_text">
            <h5>2.2.1 用户建设及应用情况<span class="dot"></span>29</h5>
            <h5>2.2.2 课程建设及应用情况<span class="dot"></span>30</h5>
            <h5>2.2.3 资源建设及应用情况<span class="dot"></span>30</h5>
            <h5>2.2.4 各省资源库建设及应用情况<span class="dot"></span>31</h5>
            <h5>
              2.2.5 {{ nowYear
              }}{{ detailYearWord }}资源库总体建设及应用情况<span
                class="dot"
              ></span
              >34
            </h5>
            <h5>2.2.6 资源库建设及应用情况排名<span class="dot"></span>38</h5>
          </div>
          <h5>3. 在线精品课程运行监测情况分析<span class="dot"></span>40</h5>
          <h5 class="Second_text">
            3.1 各省建设课程情况<span class="dot"></span>40
          </h5>
          <h5 class="Second_text">
            3.2 在线精品课访问情况<span class="dot"></span>41
          </h5>
          <h5 class="Second_text">
            3.3 在线精品课开课情况<span class="dot"></span>41
          </h5>
          <h5 class="Second_text">
            3.4 在线精品课程选课情况<span class="dot"></span>42
          </h5>
          <h5>4. 视频公开课运行监测情况分析<span class="dot"></span>42</h5>
          <h5 class="Second_text">
            4.1 各省视频公开课建设情况<span class="dot"></span>42
          </h5>
          <h5 class="Second_text">
            4.2 视频公开课访问情况<span class="dot"></span>43
          </h5>
          <h5 class="Second_text">
            4.3 视频公开课选课情况<span class="dot"></span>43
          </h5>
        </div>
      </div>

      <!-- 第一页 -->
      <div class="chart_box page-box">
        <div class="header_titles">
          <h1>国家职业教育智慧教育平台专业与课程服务中心</h1>
          <h1 style="margin-top: 20px" v-if="reportType == 1">
            {{ nowYear }}年建设及应用监测分析报告
          </h1>
          <h1 style="margin-top: 20px" v-if="reportType == 2">
            {{ nowYear }}年上半年建设及应用监测分析报告
          </h1>
          <div class="number_time">
            <div>
              <span></span>
              <span>统计时间：{{ startDay }} 至 {{ endDay }}</span>
            </div>
            <p></p>
            <p></p>
          </div>
        </div>
        <div class="chart_box">
          <div class="division">1. 专业与课程服务中心监测总体分析</div>
          <p>
            2022年3月28日，国家职业教育智慧教育平台上线，专业教学资源库与在线精品课程、视频公开课合并为专业与课程服务中心于一期上线。专业与课程服务中心监测平台（以下简称“监测平台”）随即开始对专业教学资源库、
            在线精品课及视频公开课进行运行监测并提供数据分析服务。
          </p>
          <p>
            截至{{ nowYear }}年{{ nowMonth }}月{{
              nowDay
            }}日，监测平台共接入专业教学资源库{{
              dataAll.zykNum
            }}个，在线精品课{{ dataAll.onlineCourseNum }}门，视频公开课{{
              dataAll.videoCourseNum
            }}门， 覆盖平台数{{
              platformNum.allPlatform
            }}个（包括专业教学资源库、国家级在线精品课和视频公开课的支撑平台）。专业与课程服务中心累计用户访问量达{{
              getUtils_Fun(dataAll.totalVisitNum)
            }}次，用户数{{
              getUtils_Fun(userTypeHand.total)
            }}人；参与建设的院校有{{ dataAll.schoolNum }}所；参建企业有{{
              dataAll.companyNum
            }}家； 覆盖专业数{{
              dataAll.totalProfessionCount
            }}个，其中高职专业数{{ dataAll.height_edu }}个，中职专业数{{
              dataAll.middle_edu
            }}个，职教本科专业数{{ dataAll.zjbk_edu }}个。
          </p>
        </div>
        <div class="chart_box">
          <h4>1.1 总体建设及应用分析</h4>
          <div class="chart_box">
            <h5 style="margin-top: 0">1.1.1 用户建设及应用情况</h5>
            <div class="chart_box">
              <p>
                截至{{ nowYear }}年{{ nowMonth }}月{{
                  nowDay
                }}日，注册用户总计{{
                  getUtils_Fun(userTypeHand.total)
                }}人，其中学生总数最多，共{{
                  getUtils_Fun(userTypeHand.studentNum)
                }}人，占比{{
                  (
                    (userTypeHand.studentNum / userTypeHand.total) *
                    100
                  ).toFixed(2)
                }}%， 其次是教师，共{{
                  getUtils_Fun(userTypeHand.tearchNum)
                }}人，占比{{
                  ((userTypeHand.tearchNum / userTypeHand.total) * 100).toFixed(
                    2
                  )
                }}%。具体情况如下图所示：
              </p>
              <div
                class="standards_content echartsHeight"
                style="height: 28rem"
              >
                <circularChart
                  :isShowTextColor="true"
                  :refId="'typeDistributionChart'"
                  :datas="userTypeHand.dataList"
                  :colorName="1"
                  :innerText="'数量'"
                  :titleLeft="'32%'"
                  :legendBackgroundColor="true"
                  :legendLeft="'60%'"
                  :circleSize="80"
                ></circularChart>
              </div>
              <div
                class="chart_name"
                style="margin-top: 0; margin-bottom: 30px"
              >
                图1 用户类型分布
              </div>
            </div>
            <div class="chart_box">
              <p>
                截至{{ nowYear }}年{{ nowMonth }}月{{
                  nowDay
                }}日，近一年学生用户访问总量达{{
                  userTalk.studentTotal
                }}次，教师用户访问量达{{
                  userTalk.teacherTotal
                }}次，具体访问趋势如下图所示：
              </p>
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'userTalk'"
                  :datas="userTalk.dataList"
                  :transverseData="userTalk.transverse"
                  :colorList="colorList"
                  :innerText="'单位：次'"
                  :legendList="userTalk.legendList"
                  :titleLeft="'32%'"
                  :legendBackgroundColor="true"
                  :circleSize="80"
                ></discountChart>
              </div>
              <div class="chart_name">图2 最近一年教师和学生访问情况</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二页 -->
      <div
        class="chart_box page-box flex-box"
        style="justify-content: space-between"
      >
        <div class="chart_box">
          <h5>1.1.2 课程建设及应用情况</h5>
          <p>
            截至{{ nowYear }}年{{ nowMonth }}月{{
              nowDay
            }}日，专业与课程服务中心共计{{
              getUtils_Fun(courseTypeNum.total)
            }}门课程，其中资源库的课程数量最多，占比{{
              (
                (this.courseTypeNum.maxArr.value / this.courseTypeNum.total) *
                100
              ).toFixed(2)
            }}%，具体课程来源分布如下图所示：
          </p>
          <div class="standards_content echartsHeight" style="height: 28rem">
            <circularChart
              :refId="'typeDistributionChart'"
              :isShowTextColor="true"
              :datas="courseTypeNum.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'50%'"
              :circleSize="80"
            ></circularChart>
          </div>
          <div class="chart_name" style="margin-top: 0">图3 课程来源分布</div>
        </div>

        <div class="chart_box">
          <p>
            截至{{ nowYear }}年{{ nowMonth }}月{{
              nowDay
            }}日，近一年课程被访问总量达{{
              getUtils_Fun(courseTalk.total)
            }}次，平均月访问量达{{
              getUtils_Fun(courseTalk.total / 12)
            }}次，具体访问趋势如下图所示：
          </p>
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'userTalk'"
              :datas="courseTalk.dataList"
              :transverseData="courseTalk.transverseData"
              :colorList="colorList"
              :innerText="'单位：次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
            >
            </discountChart>
          </div>
          <div class="chart_name" style="margin-top: 0">
            图4 近一年课程被访问趋势图
          </div>
        </div>

        <div class="chart_box">
          <p>
            截至{{ nowYear }}年{{ nowMonth }}月{{
              nowDay
            }}日，课程被访问总量达{{
              getUtils_Fun(courseTalkTable.courseVisitNum)
            }}次。依据专业与课程服务中心监测平台统计，被访问量居首的课程是《{{
              courseTalkTable.MaxArr.courseName
            }}》，有{{
              getUtils_Fun(courseTalkTable.MaxArr.courseTotalVisit)
            }}次，具体课程被访问量排名（前十五名）如下表所示：
          </p>
          <div class="chart_name">表1 课程被访问量排名（前十五名）</div>
          <div class="biaoge">
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              width="100%"
              bordercolor="#fff"
              class="course"
            >
              <tr class="th_tr">
                <th>排名</th>
                <th>课程名称</th>
                <th>课程来源</th>
                <th>课程负责人</th>
                <th>建设院校</th>
                <th>访问量（次）</th>
              </tr>
              <tr v-if="courseTalkTable.dataList.length == 0" class="nothing">
                <td colspan="7">无</td>
              </tr>
              <tr
                v-else
                v-for="(item, index) in courseTalkTable.dataList"
                :key="index"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.courseName }}</td>
                <td>{{ item.courseType }}</td>
                <td>{{ item.majorTeacher }}</td>
                <td>{{ item.schoolName }}</td>
                <td>{{ item.courseTotalVisit }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- 第三页 -->
      <div class="chart_box page-box">
        <h5>1.1.3 资源建设及应用情况</h5>
        <div class="chart_box">
          <p>
            截至{{ nowYear }}年{{ nowMonth }}月{{
              nowDay
            }}日，专业与课程服务中心资源总数达{{
              getUtils_Fun(educationLevel.total)
            }}条，共计容量有{{
              formatValue(educationLevel.resourceCapacityNum / 1024 / 1024)
            }}TB。 从资源类型来看，{{
              educationLevel.video.name
            }}类数量最多，有{{
              getUtils_Fun(educationLevel.video.value)
            }}条，占比{{
              (
                (educationLevel.video.value / educationLevel.total) *
                100
              ).toFixed(2)
            }}%，具体资源类型分布如下图所示：
          </p>
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'typeDistributionChart'"
              :isShowTextColor="true"
              :datas="educationLevel.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :showValue="true"
              :unit="'条'"
              :legendBackgroundColor="true"
              :legendLeft="'55%'"
              :circleSize="80"
            ></circularChart>
          </div>
          <div class="chart_name">图5 资源类型分布</div>
        </div>
        <div class="chart_box">
          <p style="margin-top: 150px">
            资源访问总量已达{{
              getUtils_Fun(educationLevel.totalVisitNum)
            }}次，其中访问次数最多的资源是《{{
              resourceTable.Max.split(",")[0]
            }}》，资源被访问量排名（前十五名）如下表所示：
          </p>
          <div class="chart_name">表2 资源被访问量排名（前十五名）</div>
          <div class="biaoge">
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              width="100%"
              bordercolor="#fff"
              class="course"
            >
              <tr class="th_tr">
                <th>排名</th>
                <th style="width: 300px">资源名称</th>
                <th>资源类型</th>
                <th>资源来源</th>
                <th>上传人</th>
                <th>建设院校</th>
                <th>访问量（次）</th>
              </tr>
              <tr v-if="resourceTable.dataList.length == 0" class="nothing">
                <td colspan="7">无</td>
              </tr>
              <tr
                v-else
                v-for="(item, index) in resourceTable.dataList"
                :key="index"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.name.split(",")[0] }}</td>
                <td>{{ item.name.split(",")[1] }}</td>
                <td>{{ item.zykName }}</td>
                <td>{{ item.author }}</td>
                <td>{{ item.school }}</td>
                <td>{{ item.num }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- 第四页 -->
      <div class="chart_box page-box">
        <h4>1.2 各省建设及应用情况分析</h4>
        <h5>1.2.1 各省用户建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
            getUtils_Fun(getUser.userTotal)
          }}人，来自{{
            provinceTalking.dataList.length
          }}个省份，其中注册用户最多的是{{ changeCity(getUser.MaxArr.name) }}，
          达{{ getUtils_Fun(getUser.MaxArr.value) }}人之多；活跃用户总数有{{
            getUtils_Fun(provinceStudy.total)
          }}人，活跃用户数最多的是{{
            changeCity(provinceStudy.MaxArr.name)
          }}，共{{
            getUtils_Fun(provinceStudy.MaxArr.value)
          }}人；互动交流次数累计{{
            getUtils_Fun(provinceTalking.total)
          }}次，互动交流频次最多的是{{
            changeCity(provinceTalking.MaxArr.name)
          }}，达{{ getUtils_Fun(provinceTalking.MaxArr.value) }}次。
        </p>
        <div class="flex-box" style="padding-bottom: 100px">
          <div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="getUser.dataList.slice(0, 15)"
                :transverseData="getUser.legendList.slice(0, 15)"
                :colorList="colorList"
              ></tcolumnarChart>
            </div>
            <div class="chart_name">图6 各省注册用户数排名（前十五名）</div>
          </div>

          <div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="provinceStudy.dataList.slice(0, 15)"
                :transverseData="provinceStudy.legendList.slice(0, 15)"
                :colorList="colorList"
              ></tcolumnarChart>
            </div>
            <div class="chart_name">图7 各省活跃用户数排名（前十五名）</div>
          </div>

          <div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="provinceTalking.dataList.slice(0, 15)"
                :transverseData="provinceTalking.legendList.slice(0, 15)"
                :colorList="colorList"
              ></tcolumnarChart>
            </div>
            <div class="chart_name">图8 各省交流互动量排名（前十五名）</div>
          </div>
        </div>
      </div>

      <!-- 第五页 -->
      <div class="chart_box page-box">
        <h5>1.2.2 各省课程建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，建设课程总数{{
            getUtils_Fun(curriculum.totalCourse)
          }}门，其中建设课程数量最多的是{{
            curriculum.MaxArr.name
          }}省，总计建设{{
            getUtils_Fun(curriculum.MaxArr.value)
          }}门课程。各省访问课程的总量达{{
            getUtils_Fun(curriculum.provinceCourse)
          }}次，访问课程总量最多的是{{ curriculum.courseObj.name[0] }}省。
        </p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :refId="'coursesOfferedChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="curriculum.dataList.slice(0, 15)"
            :transverseData="curriculum.legendList.slice(0, 15)"
            :colorList="colorList"
            :gridY="'4%'"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图9 各省建设课程数量排名（前十五名）</div>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :refId="'coursesOfferedChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="curriculum.courseObj.value.slice(0, 15)"
            :transverseData="curriculum.courseObj.name.slice(0, 15)"
            :colorList="colorList"
            :gridY="'4%'"
            style="height: 100%"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图10 各省访问课程情况排名（前十五名）</div>
        <h5>1.2.3 各省资源建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，建设资源总数{{
            getUtils_Fun(sourceMater.resourceTotalCount)
          }}条，其中建设资源数量最多的是{{
            sourceMater.MaxArr.province
          }}省，有{{
            getUtils_Fun(sourceMater.MaxArr.num)
          }}条。各省访问资源的总量达{{
            getUtils_Fun(visitProvince.total)
          }}次，访问资源总量最多的是{{ visitProvince.MaxArr.name }}省。
        </p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :refId="'coursesOfferedChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="sourceMater.dataList.slice(0, 15)"
            :transverseData="sourceMater.legendList.slice(0, 15)"
            :colorList="colorList"
            :gridY="'4%'"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图11 各省建设资源数排名（前十五名）</div>
      </div>

      <!-- 第六页 -->
      <div class="chart_box page-box">
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :refId="'coursesOfferedChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="visitProvince.dataList.slice(0, 15)"
            :transverseData="visitProvince.legendList.slice(0, 15)"
            :colorList="colorList"
            :gridY="'4%'"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图12 各省访问资源情况排名（前十五名）</div>
        <h4 style="margin-top: 100px">
          1.3 {{ nowYear }}{{ detailYearWord }}运行监测总体分析
        </h4>
        <h5>1.3.1 {{ nowYear }}{{ detailYearWord }}用户建设及应用总体情况</h5>
        <p>
          {{ nowYear }}{{ detailYearWord }}新增注册用户累计{{
            getUtils_Fun(userAdd.total)
          }}人，其中教师{{ getUtils_Fun(userAdd.Ttotal) }}人，学生{{
            getUtils_Fun(userAdd.Stotal)
          }}人。注册用户趋势如下图所示：
        </p>
        <div style="padding-bottom: 100px">
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="userAdd.dataList1"
              :transverseData="userAdd.transverse"
              :colorList="colorList"
              :legendList="userAdd.legendList"
              :innerText="'单位：人'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图13 {{ nowYear }}{{ detailYearWord }}教师和学生注册用户趋势图
          </div>
          <div
            class="standards_content echartsHeight"
            style="margin-top: 100px"
          >
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="userAdd.dataList2"
              :transverseData="userAdd.transverse"
              :colorList="colorList"
              :legendList="userAdd.tran"
              :innerText="'单位：人'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图14 {{ nowYear
            }}{{ detailYearWord }}社会学习者和企业用户注册用户趋势图
          </div>
        </div>
      </div>

      <!-- 第七页 -->
      <div class="chart_box page-box">
        <p>
          {{ nowYear }}{{ detailYearWord }}用户访问总量累计达{{
            getUtils_Fun(userTimeTalk.total)
          }}次，用户访问趋势图如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="userTimeTalk.dataList"
            :transverseData="userTimeTalk.transverse"
            :colorList="colorList"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">
          图15 {{ nowYear }}{{ detailYearWord }}用户访问趋势图
        </div>
        <h5 style="margin-top: 100px">
          1.3.2 {{ nowYear }}{{ detailYearWord }}课程建设及应用总体情况
        </h5>
        <div class="chart_box">
          <p>
            {{ nowYear }}{{ detailYearWord }}新增课程数为{{
              getUtils_Fun(courseNew.total)
            }}门，课程被访问次数达{{
              getUtils_Fun(courseTrend.total)
            }}次，课程运行趋势如下图所示：
          </p>
        </div>
        <div class="flex-box">
          <div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'resourcesMonthChart'"
                :datas="courseNew.dataList"
                :transverseData="courseNew.transverse"
                :colorList="colorList"
                :colorName="1"
                :innerText="'单位：门'"
                :isaverage="true"
              >
              </discountChart>
            </div>
            <div class="chart_name">
              图16 {{ nowYear }}{{ detailYearWord }}新增课程趋势图
            </div>
          </div>
          <div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'resourcesMonthChart'"
                :datas="courseTrend.dataList"
                :transverseData="courseTrend.transverse"
                :colorList="colorList"
                :colorName="1"
                :innerText="'单位：次'"
                :isaverage="true"
              >
              </discountChart>
            </div>
            <div class="chart_name">
              图17 {{ nowYear }}{{ detailYearWord }}课程被访问趋势图
            </div>
          </div>
        </div>
      </div>

      <!-- 第八页 -->
      <div class="chart_box page-box">
        <h5>1.3.3 {{ nowYear }}{{ detailYearWord }}资源建设及应用总体情况</h5>
        <p>
          {{ nowYear }}{{ detailYearWord }}新增资源数累计{{
            getUtils_Fun(resourceNew.total)
          }}条，资源被访问次数累计达{{
            getUtils_Fun(resourceVisits.total)
          }}次，资源运行趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="resourceNew.dataList"
            :transverseData="resourceNew.transverse"
            :colorList="colorList"
            :innerText="'单位：条'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">
          图18 {{ nowYear }}{{ detailYearWord }}新增资源趋势图
        </div>
        <div class="standards_content echartsHeight" style="margin-top: 150px">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="resourceVisits.dataList"
            :transverseData="resourceVisits.transverse"
            :colorList="colorList"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">
          图19 {{ nowYear }}{{ detailYearWord }}资源被访问趋势图
        </div>
      </div>

      <!-- 第九页 -->
      <div class="chart_box page-box">
        <div class="division">2. 职业教育专业教学资源库运行监测情况分析</div>
        <h4>2.1 {{ twoGetCountry.zykCountryNum }}个国家级资源库建设及应用情况分析</h4>
        <p>
          国家级职业教育专业教学资源库已立项建设项目共计
          {{ twoGetCountry.zykCountryNum }} 个，覆盖了所有专业大类和 {{
          twoGetCountry.countryProfessionClass
          }}
          个二级专业类。 目前，已有{{
            twoGetCountry.schoolBuild
          }}
          所职业院校和{{
            twoGetCountry.companyBuild
          }}家行业企业参与建设；标准化课程总量已达{{
            twoGetCountry.standardNum
          }}门，资源库项目资源总量达{{
            getUtils_Fun(twoGetCountry.resourceNum)
          }}余条，资源库共有注册用户
          {{ getUtils_Fun(userTypeList.total) }}余人，总访问次数{{
            getUtils_Fun(twoGetCountry.totalZykVisitNum)
          }}次，支撑平台数{{ platformNum.countryZykPlatform }}个。
        </p>
        <h5>2.1.1 用户建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，国家级职业教育专业教学资源库共有注册用户{{
            getUtils_Fun(userTypeList.total)
          }}余人，按用户身份类型统计，{{ userTypeList.tearchNum.name
          }}{{ getUtils_Fun(userTypeList.tearchNum.value) }}余人，学生{{
            getUtils_Fun(userTypeList.studentNum.value)
          }}余人。资源库共有{{ userTypeList.companyNum.name
          }}{{
            getUtils_Fun(userTypeList.companyNum.value)
          }}人，较好地考虑了企业员工继续教育、技能提升的需求，合作企业实现了依托资源库开展员工继续教育培训；资源库共有{{
            userTypeList.socialNum.name
          }}{{
            getUtils_Fun(userTypeList.socialNum.value)
          }}余人，承担了面向普通劳动者的免费线上培训的社会责任。资源库用户访问资源总量约{{
            getUtils_Fun(talkAll.resource)
          }}次，用户访问课程总量约{{
            getUtils_Fun(talkAll.course)
          }}次，用户互动交流次数约{{ getUtils_Fun(talkAll.user) }}次。
        </p>
        <p>具体用户分布详情如下图所示：</p>
        <div class="flex-box">
          <div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'typeDistributionChart'"
                :isShowTextColor="true"
                :datas="userTypeList.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">
              图20 国家级资源库用户整体情况（单位：人）
            </div>
          </div>
          <div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'typeDistributionChart'"
                :isShowTextColor="true"
                :datas="studentConstruction.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">
              图21 国家级资源库学生类型整体情况（单位：人）
            </div>
          </div>
        </div>
      </div>

      <!-- 第十页 -->
      <div class="chart_box page-box">
        <h5>2.1.2 课程建设及应用情况</h5>
        <div class="chart_box">
          <p>
            截至{{ nowYear }}年{{ nowMonth }}月{{
              nowDay
            }}日，国家级职业教育专业教学资源库课程建设总量达到{{
              getUtils_Fun(getcourse.courseNum)
            }}门，其中标准化课程{{
              getUtils_Fun(getcourse.dataList[0])
            }}门，个性化课程{{
              getUtils_Fun(getcourse.dataList[1])
            }}门，注册学生数最多的课程名《{{
              getcourse.courseMaxCount.name &&
              getcourse.courseMaxCount.name.split("-")[0]
            }}》是属于{{ getcourse.courseMaxCount.zykName }}资源库。{{
              getcourse.courseMaxCount.zykDiv
            }}%资源库中的项目课程(标准化课程)数量大于 10
            门，课程按类型分布详情如下图所示：
          </p>
          <div class="standards_content echartsHeight">
            <tcolumnarChart
              :refId="'resourcesMonthChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="getcourse.dataList"
              :transverseData="getcourse.transverseData"
              :colorList="colorList"
            >
            </tcolumnarChart>
          </div>
        </div>
        <div class="chart_name" style="margin-bottom: 100px">
          图22 国家级资源库课程整体情况（单位：门）
        </div>
        <h5>2.1.3 资源建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，国家级职业教育专业教学资源库资源数量达{{
            getUtils_Fun(buildAndAppAnalysis.resourceNum)
          }}余条，
          资源总量不断扩大，解决了传统教学中“讲不清、看不到、进不去、动不得、难再现”的问题；表现形式日趋丰富，更受年轻人喜爱的{{
            buildAndAppAnalysis.maxArr.name
          }}类教学资源数量独占鳌头，达到{{
            getUtils_Fun(buildAndAppAnalysis.maxArr.value)
          }}条，除此之外，各资源库项目还开发了大量的实践教学资源，拥有{{
            getUtils_Fun(buildAndAppAnalysis.xuni.value)
          }}个{{ buildAndAppAnalysis.xuni.name }}资源, 资源总容量达{{
            formatValue(buildAndAppAnalysis.resourceCapacityNum / 1024 / 1024)
          }}TB，资源访问总量已达{{
            getUtils_Fun(buildAndAppAnalysis.resourceTotal)
          }}余次。
        </p>
        <p>
          其中访问次数最多的资源是《{{
            buildAndAppAnalysis.visitMaxResource.name
          }}》，属于{{
            buildAndAppAnalysis.visitMaxResource.zykName
          }}。资源按类型分布详情如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :refId="'resourcesMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="buildAndAppAnalysis.value"
            :transverseData="buildAndAppAnalysis.name"
            :colorList="colorList"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图23 国家级资源库资源整体情况（单位：条）</div>
      </div>

      <!-- 第十一页 -->
      <div class="chart_box page-box">
        <h5>2.1.4 按专业大类汇总统计分析</h5>
        <h6>2.1.4.1 专业大类总体分析情况</h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，国家级资源库覆盖{{
            getmajor.dataList.length - 1
          }}个专业大类。从专业大类分布看，属于{{
            getmajor.MaxArr.name
          }}的资源库最多，占比达{{
            ((getmajor.MaxArr.value / getmajor.total) * 100).toFixed(2)
          }}%，具体可归属专业大类的资源库分布如下图所示：
        </p>
        <div class="standards_content echartsHeight" style="height: 480px">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="getmajor.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'20%'"
            :showValue="true"
            :unit="'个'"
            :legendBackgroundColor="true"
            :legendLeft="'40%'"
            :circleSize="80"
            :seriesRight="'60%'"
          >
          </circularChart>
        </div>
        <div class="chart_name">图24 专业大类分布情况</div>
        <p style="margin-top: 150px">
          各专业大类资源库的建设及应用总体情况如下表所示。每个专业大类下属各资源库的建设及应用情况汇总见附件一。我们详细分析了排在前四的专业大类的资源库情况。
        </p>
        <div class="chart_name">表3 各专业大类国家级资源库建设情况汇总表</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr class="th_tr">
              <th>序号</th>
              <th>所属专业大类</th>
              <th>资源库数</th>
              <th>用户总数</th>
              <th>资源总数</th>
              <th>课程总数</th>
              <th>标准化课程数</th>
              <th>活跃教师数</th>
              <th>活跃学生数</th>
              <th>总访问量</th>
            </tr>
            <tr
              v-if="ProfessionBigClassAnalysisArr.length == 0"
              class="nothing"
            >
              <td colspan="10">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in ProfessionBigClassAnalysisArr"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.professionBigClass }}</td>
              <td>{{ item.zykNum }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.totalCourse }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.totalVisit }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第十二页 -->
      <div class="chart_box page-box">
        <h6>2.1.4.2 装备制造大类专业教学资源库建设及应用数据分析</h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，国家级职业教育{{
            ProfessionAnalysis.top1Data.bigClass
          }}专业教学资源库已立项建设项目共计{{
            ProfessionAnalysis.top1Data.zykCount
          }}个，已有{{ ProfessionAnalysis.top1Data.schoolNum }}所职业院校和{{
            ProfessionAnalysis.top1Data.companyCount
          }}行业企业参与建设；标准化课程总量已达{{
            ProfessionAnalysis.top1Data.standardNum
          }}门，该专业大类资源总量达{{
            getUtils_Fun(ProfessionAnalysis.top1Data.resourceNum)
          }}条。共有注册用户{{
            getUtils_Fun(ProfessionAnalysis.top1Data.totalUser)
          }}人，按用户身份类型统计，教师{{
            getUtils_Fun(ProfessionAnalysis.top1Data.userTypeCount.teacher)
          }}人,学生{{
            getUtils_Fun(ProfessionAnalysis.top1Data.userTypeCount.student)
          }}人，企业用户{{
            getUtils_Fun(ProfessionAnalysis.top1Data.userTypeCount.enterprise)
          }}人，社会学习者用户{{
            getUtils_Fun(ProfessionAnalysis.top1Data.userTypeCount.social)
          }}人，用户访问资源总量{{
            getUtils_Fun(ProfessionAnalysis.top1Data.resourceVisit)
          }}次,用户访问课程总量{{
            getUtils_Fun(ProfessionAnalysis.top1Data.courseVisit)
          }}次，用户互动交流次数{{
            getUtils_Fun(ProfessionAnalysis.top1Data.forumVisit)
          }}次。
        </p>
        <p>
          {{
            ProfessionAnalysis.top1Data.bigClass
          }}专业教学资源库建设及应用情况具体如下表所示：
        </p>
        <div class="chart_name">
          表4 装备制造大类国家级专业教学资源库建设及应用情况
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr class="th_tr">
              <th>序号</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程数</th>
              <th>课程总数</th>
            </tr>
            <tr v-if="ProfessionAnalysis.top1List.length == 0" class="nothing">
              <td colspan="11">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in ProfessionAnalysis.top1List"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>
            <tr v-if="ProfessionAnalysis.top1List.length > 0">
              <td>合计</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>{{ ProfessionAnalysis.top1Data.totalVisit }}</td>
              <td>{{ ProfessionAnalysis.top1Data.totalUser }}</td>
              <td>{{ ProfessionAnalysis.top1Data.activeStudentNum }}</td>
              <td>{{ ProfessionAnalysis.top1Data.activeTeacherNum }}</td>
              <td>{{ ProfessionAnalysis.top1Data.totalResource }}</td>
              <td>{{ ProfessionAnalysis.top1Data.standardCourse }}</td>
              <td>{{ ProfessionAnalysis.top1Data.totalCourse }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第十三页 -->
      <div class="chart_box page-box">
        <p>
          自{{ nowYear }}年1月1日以来，{{
            ProfessionAnalysis.top1Data.bigClass
          }}国家级资源库新增用户数{{
            getUtils_Fun(ProfessionAnalysis.top1Data.currentYearUserAdd)
          }}人，其中新增教师{{
            getUtils_Fun(ProfessionAnalysis.top1Data.currentYearTeacherAdd)
          }}人，新增学生{{
            getUtils_Fun(ProfessionAnalysis.top1Data.currentYearStudentAdd)
          }}人。新增资源数{{
            getUtils_Fun(ProfessionAnalysis.top1Data.currentYearResourceAdd)
          }}条；新增课程数{{
            getUtils_Fun(ProfessionAnalysis.top1Data.currentYearCourseAdd)
          }}门。累计登录用户{{
            getUtils_Fun(ProfessionAnalysis.top1Data.currentYearActiveUser)
          }}人，累计访问{{
            getUtils_Fun(ProfessionAnalysis.top1Data.currentYearVisit)
          }}次。各类型用户日访问走势如下图所示：
        </p>
        <div class="flex-box">
          <div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList1.dataList1.value"
                :transverseData="ProfessionVisitBar.dataList1.dataList1.name"
                :colorList="colorList"
                :legendList="['学生']"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图25 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日学生访问情况
            </div>
          </div>
          <div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList1.dataList2.value"
                :transverseData="ProfessionVisitBar.dataList1.dataList2.name"
                :colorList="colorList"
                :legendList="['教师']"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图26 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日教师访问情况
            </div>
          </div>
          <div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList1.dataList3.value"
                :transverseData="ProfessionVisitBar.dataList1.dataList3.name"
                :colorList="colorList"
                :legendList="['企业用户']"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图27 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日企业用户访问情况
            </div>
          </div>
        </div>
      </div>

      <!-- 第十四页 -->
      <div class="chart_box page-box">
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'visitsMonthChart'"
            :datas="ProfessionVisitBar.dataList1.dataList4.value"
            :transverseData="ProfessionVisitBar.dataList1.dataList4.name"
            :colorList="colorList"
            :legendList="['社会学习者']"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">
          图28 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日社会学习者访问情况
        </div>
        <h6 style="margin-top: 100px">
          2.1.4.3
          {{
            ProfessionAnalysis.top2Data.bigClass
          }}专业教学资源库建设及应用数据分析
        </h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，国家级职业教育{{
            ProfessionAnalysis.top2Data.bigClass
          }}专业教学资源库已立项建设项目共计{{
            ProfessionAnalysis.top2Data.zykCount
          }}个，已有{{ ProfessionAnalysis.top2Data.schoolNum }}所职业院校和{{
            ProfessionAnalysis.top2Data.companyCount
          }}行业企业参与建设；标准化课程总量已达{{
            getUtils_Fun(ProfessionAnalysis.top2Data.standardNum)
          }}门，该专业大类资源总量达{{
            getUtils_Fun(ProfessionAnalysis.top2Data.resourceNum)
          }}条 。注册用户{{
            getUtils_Fun(ProfessionAnalysis.top2Data.totalUser)
          }}人，按用户身份类型统计， 教师{{
            getUtils_Fun(ProfessionAnalysis.top2Data.userTypeCount.teacher)
          }}人，学生{{
            getUtils_Fun(ProfessionAnalysis.top2Data.userTypeCount.student)
          }}人，企业用户{{
            getUtils_Fun(ProfessionAnalysis.top2Data.userTypeCount.enterprise)
          }}人，社会学习者用户{{
            getUtils_Fun(ProfessionAnalysis.top2Data.userTypeCount.social)
          }}人，用户访问资源总量{{
            getUtils_Fun(ProfessionAnalysis.top2Data.resourceVisit)
          }}次、用户访问课程总量{{
            getUtils_Fun(ProfessionAnalysis.top2Data.courseVisit)
          }}次，用户互动交流次数{{
            getUtils_Fun(ProfessionAnalysis.top2Data.forumVisit)
          }}次。
        </p>
        <p>
          {{
            ProfessionAnalysis.top2Data.bigClass
          }}专业教学资源库建设及应用情况具体如下表所示：
        </p>
        <div class="chart_name">
          表5
          {{
            ProfessionAnalysis.top2Data.bigClass
          }}国家级专业教学资源库建设及应用情况一览表
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr class="th_tr">
              <th>序号</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程数</th>
              <th>课程总数</th>
            </tr>

            <tr v-if="ProfessionAnalysis.top2List.length == 0" class="nothing">
              <td colspan="11">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in ProfessionAnalysis.top2List"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>

            <tr v-if="ProfessionAnalysis.top2List.length > 0">
              <td>合计</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>{{ ProfessionAnalysis.top2Data.totalVisit }}</td>
              <td>{{ ProfessionAnalysis.top2Data.totalUser }}</td>
              <td>{{ ProfessionAnalysis.top2Data.activeStudentNum }}</td>
              <td>{{ ProfessionAnalysis.top2Data.activeTeacherNum }}</td>
              <td>{{ ProfessionAnalysis.top2Data.totalResource }}</td>
              <td>{{ ProfessionAnalysis.top2Data.standardCourse }}</td>
              <td>{{ ProfessionAnalysis.top2Data.totalCourse }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第十五页 -->
      <div class="chart_box page-box">
        <p>
          自{{ nowYear }}年1月1日以来，{{
            ProfessionAnalysis.top2Data.bigClass
          }}国家级资源库新增用户数{{
            getUtils_Fun(ProfessionAnalysis.top2Data.currentYearUserAdd)
          }}人，其中新增教师{{
            getUtils_Fun(ProfessionAnalysis.top2Data.currentYearTeacherAdd)
          }}人，新增学生{{
            getUtils_Fun(ProfessionAnalysis.top2Data.currentYearStudentAdd)
          }}人。新增资源数{{
            getUtils_Fun(ProfessionAnalysis.top2Data.currentYearResourceAdd)
          }}条；新增课程数{{
            ProfessionAnalysis.top2Data.currentYearCourseAdd
          }}门。累计登录用户{{
            getUtils_Fun(ProfessionAnalysis.top2Data.currentYearActiveUser)
          }}人，累计访问{{
            getUtils_Fun(ProfessionAnalysis.top2Data.currentYearVisit)
          }}次。各类型用户日访问走势如下图所示：
        </p>
        <div class="flex-box" style="padding-bottom: 100px">
          <div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList2.dataList1.value"
                :transverseData="ProfessionVisitBar.dataList2.dataList1.name"
                :colorList="colorList"
                :legendList="['学生']"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图29 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日学生访问情况
            </div>
          </div>
          <div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList2.dataList2.value"
                :transverseData="ProfessionVisitBar.dataList2.dataList2.name"
                :colorList="colorList"
                :legendList="['教师']"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图30 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日教师访问情况
            </div>
          </div>
          <div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList2.dataList3.value"
                :transverseData="ProfessionVisitBar.dataList2.dataList3.name"
                :colorList="colorList"
                :legendList="['企业用户']"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图31 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日企业用户访问情况
            </div>
          </div>
        </div>
      </div>

      <!-- 第十六页 -->
      <div class="chart_box page-box">
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'visitsMonthChart'"
            :datas="ProfessionVisitBar.dataList2.dataList4.value"
            :transverseData="ProfessionVisitBar.dataList2.dataList4.name"
            :colorList="colorList"
            :legendList="['社会学习者']"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">
          图32 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日社会学习者用户访问情况
        </div>
        <h6 style="margin-top: 50px">
          2.1.4.4
          {{
            ProfessionAnalysis.top3Data.bigClass
          }}专业教学资源库建设及应用数据分析
        </h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，国家级职业教育{{
            ProfessionAnalysis.top3Data.bigClass
          }}专业教学资源库已立项建设项目共计{{
            ProfessionAnalysis.top3Data.zykCount
          }}个，已有{{ ProfessionAnalysis.top3Data.schoolNum }} 所职业院校和{{
            ProfessionAnalysis.top3Data.companyCount
          }}行业企业参与建设；标准化课程总量已达{{
            ProfessionAnalysis.top3Data.standardNum
          }}门，该专业大类资源总量达{{
            getUtils_Fun(ProfessionAnalysis.top3Data.resourceNum)
          }}条。共有注册用户{{
            getUtils_Fun(ProfessionAnalysis.top3Data.totalUser)
          }}人，按用户身份类型统计， 教师{{
            getUtils_Fun(ProfessionAnalysis.top3Data.userTypeCount.teacher)
          }}人，学生{{
            getUtils_Fun(ProfessionAnalysis.top3Data.userTypeCount.student)
          }}人，企业用户{{
            getUtils_Fun(ProfessionAnalysis.top3Data.userTypeCount.enterprise)
          }}人，社会学习者用户{{
            getUtils_Fun(ProfessionAnalysis.top3Data.userTypeCount.social)
          }}人，整体用户访问资源总量{{
            getUtils_Fun(ProfessionAnalysis.top3Data.resourceVisit)
          }}次，用户访问课程总量{{
            getUtils_Fun(ProfessionAnalysis.top3Data.courseVisit)
          }}次，用户互动交流次数{{
            getUtils_Fun(ProfessionAnalysis.top3Data.forumVisit)
          }}次。
        </p>
        <p>
          {{
            ProfessionAnalysis.top3Data.bigClass
          }}专业教学资源库建设及应用情况具体如下表所示：
        </p>
        <div class="chart_name">
          表6
          {{
            ProfessionAnalysis.top3Data.bigClass
          }}国家级专业教学资源库建设及应用情况一览表
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr class="th_tr">
              <th>序号</th>
              <th style="width: 230px">资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程数</th>
              <th>课程总数</th>
            </tr>

            <tr v-if="ProfessionAnalysis.top3List.length == 0" class="nothing">
              <td colspan="11">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in ProfessionAnalysis.top3List"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>

            <tr v-if="ProfessionAnalysis.top3List.length > 0">
              <td>合计</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>{{ ProfessionAnalysis.top3Data.totalVisit }}</td>
              <td>{{ ProfessionAnalysis.top3Data.totalUser }}</td>
              <td>{{ ProfessionAnalysis.top3Data.activeStudentNum }}</td>
              <td>{{ ProfessionAnalysis.top3Data.activeTeacherNum }}</td>
              <td>{{ ProfessionAnalysis.top3Data.totalResource }}</td>
              <td>{{ ProfessionAnalysis.top3Data.standardCourse }}</td>
              <td>{{ ProfessionAnalysis.top3Data.totalCourse }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第十七页 -->
      <div class="chart_box page-box">
        <p>
          自{{ nowYear }}年1月1日以来，{{
            ProfessionAnalysis.top3Data.bigClass
          }}国家级资源库新增用户数{{
            getUtils_Fun(ProfessionAnalysis.top3Data.currentYearUserAdd)
          }}人，其中新增教师{{
            getUtils_Fun(ProfessionAnalysis.top3Data.currentYearTeacherAdd)
          }}人，新增学生{{
            getUtils_Fun(ProfessionAnalysis.top3Data.currentYearStudentAdd)
          }}人。新增资源数{{
            getUtils_Fun(ProfessionAnalysis.top3Data.currentYearResourceAdd)
          }}条；新增课程数{{
            ProfessionAnalysis.top3Data.currentYearCourseAdd
          }}门。累计登录用户{{
            getUtils_Fun(ProfessionAnalysis.top3Data.currentYearActiveUser)
          }}人，累计访问{{
            getUtils_Fun(ProfessionAnalysis.top3Data.currentYearVisit)
          }}次。各类型用户日访问走势图如下图所示：
        </p>
        <div class="flex-box" style="padding-bottom: 100px">
          <div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList3.dataList1.value"
                :transverseData="ProfessionVisitBar.dataList3.dataList1.name"
                :colorList="colorList"
                :legendList="['学生']"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图33 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日学生访问情况
            </div>
          </div>
          <div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList3.dataList2.value"
                :transverseData="ProfessionVisitBar.dataList3.dataList2.name"
                :colorList="colorList"
                :legendList="['教师']"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图34 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日教师访问情况
            </div>
          </div>

          <div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList3.dataList3.value"
                :transverseData="ProfessionVisitBar.dataList3.dataList3.name"
                :colorList="colorList"
                :legendList="['企业用户']"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图35 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日企业用户访问情况
            </div>
          </div>
        </div>
      </div>

      <!-- 第十八页 -->
      <div class="chart_box page-box">
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'visitsMonthChart'"
            :datas="ProfessionVisitBar.dataList3.dataList4.value"
            :transverseData="ProfessionVisitBar.dataList3.dataList4.name"
            :colorList="colorList"
            :legendList="['社会学习者']"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">
          图36 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日社会学习者用户访问情况
        </div>
        <h6>
          2.1.4.5
          {{
            ProfessionAnalysis.top4Data.bigClass
          }}专业教学资源库建设及应用数据分析
        </h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，国家级职业教育{{
            ProfessionAnalysis.top4Data.bigClass
          }}专业教学资源库已立项建设项目共计{{
            ProfessionAnalysis.top4Data.zykCount
          }}个， 已有{{ ProfessionAnalysis.top4Data.schoolNum }}所职业院校和{{
            ProfessionAnalysis.top4Data.companyCount
          }}行业企业参与建设；标准化课程总量已达{{
            ProfessionAnalysis.top4Data.standardNum
          }}门，该专业大类资源总量达{{
            getUtils_Fun(ProfessionAnalysis.top4Data.resourceNum)
          }}条。共有注册用户{{
            getUtils_Fun(ProfessionAnalysis.top4Data.totalUser)
          }}人，按用户身份类型统计， 教师{{
            getUtils_Fun(ProfessionAnalysis.top4Data.userTypeCount.teacher)
          }}人，学生{{
            getUtils_Fun(ProfessionAnalysis.top4Data.userTypeCount.student)
          }}人，企业用户{{
            getUtils_Fun(ProfessionAnalysis.top4Data.userTypeCount.enterprise)
          }}人，社会学习者用户{{
            getUtils_Fun(ProfessionAnalysis.top4Data.userTypeCount.social)
          }}人，整体用户访问资源总量{{
            getUtils_Fun(ProfessionAnalysis.top4Data.resourceVisit)
          }}次，用户访问课程总量{{
            getUtils_Fun(ProfessionAnalysis.top4Data.courseVisit)
          }}次，用户互动交流次数{{
            getUtils_Fun(ProfessionAnalysis.top4Data.forumVisit)
          }}次。
        </p>
        <p>
          {{
            ProfessionAnalysis.top4Data.bigClass
          }}专业教学资源库建设及应用情况具体如下表所示：
        </p>
        <div class="chart_name">
          表7
          {{
            ProfessionAnalysis.top4Data.bigClass
          }}国家级专业教学资源库建设及应用情况一览表
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr class="th_tr">
              <th>序号</th>
              <th>资源库名称</th>
              <th>资源库编码</th>
              <th>第一主持学校</th>
              <th>总访问次数</th>
              <th>总用户数</th>
              <th>活跃学生数</th>
              <th>活跃教师数</th>
              <th>资源总数</th>
              <th>标准化课程数</th>
              <th>课程总数</th>
            </tr>

            <tr v-if="ProfessionAnalysis.top4List.length == 0" class="nothing">
              <td colspan="11">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in ProfessionAnalysis.top4List"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.zyk_num }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.totalVisit }}</td>
              <td>{{ item.totalUser }}</td>
              <td>{{ item.activeStudentNum }}</td>
              <td>{{ item.activeTeacherNum }}</td>
              <td>{{ item.totalResource }}</td>
              <td>{{ item.standardCourse }}</td>
              <td>{{ item.totalCourse }}</td>
            </tr>

            <tr v-if="ProfessionAnalysis.top4List.length > 0">
              <td>合计</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>{{ ProfessionAnalysis.top4Data.totalVisit }}</td>
              <td>{{ ProfessionAnalysis.top4Data.totalUser }}</td>
              <td>{{ ProfessionAnalysis.top4Data.activeStudentNum }}</td>
              <td>{{ ProfessionAnalysis.top4Data.activeTeacherNum }}</td>
              <td>{{ ProfessionAnalysis.top4Data.totalResource }}</td>
              <td>{{ ProfessionAnalysis.top4Data.standardCourse }}</td>
              <td>{{ ProfessionAnalysis.top4Data.totalCourse }}</td>
            </tr>
          </table>
        </div>
        <p style="margin-top: 30px">
          自{{ nowYear }}年1月1日以来，{{
            ProfessionAnalysis.top4Data.bigClass
          }}国家级资源库新增用户数{{
            getUtils_Fun(ProfessionAnalysis.top4Data.currentYearUserAdd)
          }}人，其中新增教师{{
            getUtils_Fun(ProfessionAnalysis.top4Data.currentYearTeacherAdd)
          }}人，新增学生{{
            getUtils_Fun(ProfessionAnalysis.top4Data.currentYearStudentAdd)
          }}人。新增资源数{{
            getUtils_Fun(ProfessionAnalysis.top4Data.currentYearResourceAdd)
          }}条；新增课程数{{
            ProfessionAnalysis.top4Data.currentYearCourseAdd
          }}门。累计登录用户{{
            getUtils_Fun(ProfessionAnalysis.top4Data.currentYearActiveUser)
          }}人，累计访问{{
            getUtils_Fun(ProfessionAnalysis.top4Data.currentYearVisit)
          }}次。各类型用户日访问走势图如下图所示：
        </p>
      </div>

      <!-- 第十九页 -->
      <div class="chart_box flex-box page-box">
        <div>
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ProfessionVisitBar.dataList4.dataList1.value"
              :transverseData="ProfessionVisitBar.dataList4.dataList1.name"
              :colorList="colorList"
              :legendList="['学生']"
              :innerText="'单位：次'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图37 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
              nowDay
            }}日学生访问情况
          </div>
        </div>
        <div>
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ProfessionVisitBar.dataList4.dataList2.value"
              :transverseData="ProfessionVisitBar.dataList4.dataList2.name"
              :colorList="colorList"
              :legendList="['教师']"
              :innerText="'单位：次'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图38 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
              nowDay
            }}日教师访问情况
          </div>
        </div>
        <div>
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ProfessionVisitBar.dataList4.dataList3.value"
              :transverseData="ProfessionVisitBar.dataList4.dataList3.name"
              :colorList="colorList"
              :legendList="['企业用户']"
              :innerText="'单位：次'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图39 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
              nowDay
            }}日企业用户访问情况
          </div>
        </div>
      </div>

      <!-- 第二十页 -->
      <div class="chart_box page-box">
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'visitsMonthChart'"
            :datas="ProfessionVisitBar.dataList4.dataList4.value"
            :transverseData="ProfessionVisitBar.dataList4.dataList4.name"
            :colorList="colorList"
            :legendList="['社会学习者']"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">
          图40 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日社会学习者访问情况
        </div>
        <h5 style="margin-top: 100px">2.1.5 各省国家级资源库建设及应用情况</h5>
        <div class="chart_box">
          <h6>2.1.5.1 各省国家级资源库建设及应用情况概览</h6>
        </div>
        <div class="chart_name">表8 各省国家级资源库建设及应用情况概览</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr class="th_tr">
              <th>序号</th>
              <th>省份</th>
              <th>资源库总数</th>
              <th>素材资源总数</th>
              <th>标准化课程总数</th>
              <th>总用户数</th>
              <th>活跃教师数</th>
              <th>活跃学生数</th>
              <th>总访问量</th>
            </tr>
            <tr v-if="getzykTable.dataList.length == 0" class="nothing">
              <td colspan="9">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in getzykTable.dataList"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province1 }}</td>
              <td>{{ item.zykCount }}</td>
              <td>{{ item.resourceCount }}</td>
              <td>{{ item.courseCount }}</td>
              <td>{{ item.userCount }}</td>
              <td>{{ item.totalActiveTeacherNum }}</td>
              <td>{{ item.totalActiveStudentNum }}</td>
              <td>{{ item.logNum }}</td>
            </tr>
            <tr v-if="getzykTable.dataList.length > 0">
              <td>合计</td>
              <td>-</td>
              <td>{{ zykTableAmount.zykCount }}</td>
              <td>{{ zykTableAmount.resourceCount }}</td>
              <td>{{ zykTableAmount.courseCount }}</td>
              <td>{{ zykTableAmount.userCount }}</td>
              <td>{{ zykTableAmount.totalActiveTeacherNum }}</td>
              <td>{{ zykTableAmount.totalActiveStudentNum }}</td>
              <td>{{ zykTableAmount.logNum }}</td>
            </tr>
          </table>
        </div>
        <p class="notes">
          注：“各省资源库”
          均以该资源库的第一主持院校所在地来确定该资源库所归属的省份。
        </p>
      </div>

      <!-- 第二十一页 -->
      <div class="chart_box page-box">
        <h6>2.1.5.2 各省国家级资源库用户建设及应用情况</h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，国家级资源库注册用户总计{{
            getUtils_Fun(userTypeList.total)
          }}人，其中注册用户最多的是{{
            changeCity(countryLevelUserProvince.maxUserProvinceInfo.province)
          }}资源库，达{{
            getUtils_Fun(countryLevelUserProvince.maxUserProvinceInfo.maxValue)
          }}人；交流互动次数累计{{
            getUtils_Fun(countryLevelUserProvince.formunInfo.total)
          }}次，互动交流频次最多的是{{
            changeCity(countryLevelUserProvince.formunInfo.province)
          }}资源库，达{{
            getUtils_Fun(countryLevelUserProvince.formunInfo.maxValue)
          }}次；活跃用户总人数{{
            getUtils_Fun(countryLevelUserProvince.activeUserInfo.total)
          }}人，活跃用户数最多的是{{
            changeCity(countryLevelUserProvince.activeUserInfo.province)
          }}资源库，共{{
            getUtils_Fun(countryLevelUserProvince.activeUserInfo.maxValue)
          }}人。 具体各省资源库用户按照活跃用户数排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          表9 各省国家级资源库活跃用户数排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr class="th_tr">
              <th>排名</th>
              <th>省份</th>
              <th>资源库数 (个)</th>
              <th>注册用户数 (人)</th>
              <th>交流互动量 (次)</th>
              <th>活跃用户数 (人)</th>
            </tr>
            <tr
              v-if="countryLevelUserProvince.dataList.length == 0"
              class="nothing"
            >
              <td colspan="6">无</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in countryLevelUserProvince.dataList.slice(
                0,
                15
              )"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.zykCount }}</td>
              <td>{{ item.num }}</td>
              <td>{{ item.formun }}</td>
              <td>{{ item.activeNum }}</td>
            </tr>
          </table>
        </div>
        <div class="chart_box">
          <div class="standards_content echartsHeight" style="height: 1000px">
            <distributionChart
              :refId="'userTalk'"
              :datas="userProvince.mapdatas"
              :color="mapcolorList"
              :isExportFont="18"
              :zoom="true"
            ></distributionChart>
          </div>
          <div class="chart_name">图41 各省国家级资源库访问量热力图</div>
        </div>
      </div>

      <!-- 第二十二页 -->
      <div class="chart_box page-box">
        <h6>2.1.5.3 各省国家级资源库课程建设及应用情况</h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，资源库建设课程总计{{
            getUtils_Fun(
              countryCourseCountProvinceRank_obj.zykCourseBuildCountNum
            )
          }}门，其中建设课程数量最多的是{{
            countryCourseCountProvinceRank_obj.zykCourseMaxProvince.name
          }}资源库，有{{
            getUtils_Fun(
              countryCourseCountProvinceRank_obj.zykCourseMaxProvince.value
            )
          }}门；标准化课程数累计有{{
            countryCourseCountProvinceRank_obj.standardNum
          }}门，标准化课程数最多的是{{
            countryCourseCountProvinceRank_obj.countryCourseStandardCountMax
              .name
          }}资源库，共{{
            countryCourseCountProvinceRank_obj.countryCourseStandardCountMax
              .value
          }}门；个性化课程数累计有{{
            getUtils_Fun(countryCourseCountProvinceRank_obj.pnum)
          }}门，个性化课程数最多的{{
            countryCourseCountProvinceRank_obj.countryCoursePersonalityCountMax
              .name
          }}资源库，有{{
            getUtils_Fun(
              countryCourseCountProvinceRank_obj
                .countryCoursePersonalityCountMax.value
            )
          }}门。 具体各省按照总课程数排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          表10 各省国家级资源库总课程数排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr class="th_tr">
              <th>排名</th>
              <th>省份</th>
              <th>标准化课程数 (个)</th>
              <th>个性化课程数</th>
              <th>总课程数 (门)</th>
            </tr>
            <tr
              v-if="
                countryCourseCountProvinceRank_obj
                  .countryCourseCountProvinceRank.length == 0
              "
              class="nothing"
            >
              <td colspan="5">无</td>
            </tr>
            <tr
              v-else
              v-for="(
                item, index
              ) in countryCourseCountProvinceRank_obj.countryCourseCountProvinceRank.slice(
                0,
                15
              )"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.snum }}</td>
              <td>{{ item.pnum }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
        <h6 style="margin-top: 100px">
          2.1.5.4 各省国家级资源库资源建设及应用情况
        </h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，资源库建设资源累计达{{
            getUtils_Fun(getCountryProvinceZykBuild.zykBuildResourceCount)
          }}条，其中建设资源数量最多的是{{
            changeCity(getCountryProvinceZykBuild.zykNumMaxProvince.province)
          }}资源库，有{{
            getUtils_Fun(getCountryProvinceZykBuild.zykNumMaxProvince.num)
          }}条。各省访问资源的总量达{{
            getUtils_Fun(getCountryProvinceZykBuild.countryResourceTotalLog)
          }}次，访问资源总量最多的是{{
            changeCity(getCountryProvinceZykBuild.resourceVisitMaxProvince)
          }}资源库。具体各省资源库资源按访问情况排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          表11 各省国家级资源库资源访问量情况排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr class="th_tr">
              <th>排名</th>
              <th>省份</th>
              <th>资源数（条）</th>
              <th>资源量（TB）</th>
              <th>访问量（次）</th>
            </tr>
            <tr
              v-if="
                getCountryProvinceZykBuild.countryResourceProvinceStateRank
                  .length == 0
              "
              class="nothing"
            >
              <td colspan="5">无</td>
            </tr>
            <tr
              v-else
              v-for="(
                item, index
              ) in getCountryProvinceZykBuild.countryResourceProvinceStateRank.slice(
                0,
                15
              )"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.count }}</td>
              <td>{{ item.disksNum }}</td>
              <td>{{ item.log }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第二十三页 -->
      <div class="chart_box page-box">
        <h5>
          2.1.6 国家级资源库{{ nowYear }}{{ detailYearWord }}建设及应用情况
        </h5>
        <h6>2.1.6.1 用户新增情况</h6>
        <div class="flex-box">
          <div class="chart_box">
            <!-- {{
                getReduceOrAdd(
                  ZykStudentUser.secondTotal - ZykStudentUser.firstTotal
                )
              }} -->
            <p>
              {{ nowYear }}{{ detailYearWord }}国家级资源库学生新增共{{
                getUtils_Fun(ZykStudentUser.secondTotal)
              }}人，较{{ nowYear - 1 }}{{ detailYearWord }}{{
              getReduceOrAdd(
              ZykStudentUser.secondTotal - ZykStudentUser.firstTotal
              )
              }}人。
            </p>
            <div class="echarts-box">
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'visitsMonthChart'"
                  :datas="ZykStudentUser.dataList"
                  :transverseData="ZykStudentUser.studentSecondTimeDay"
                  :colorList="colorList"
                  :innerText="'单位：人'"
                  :isaverage="true"
                  :legendList="[nowYear, (nowYear - 1).toString()]"
                ></discountChart>
              </div>
              <div class="chart_name">
                图42 {{ nowYear }}{{ detailYearWord }}学生新增情况与{{
                  nowYear - 1
                }}年同期对比分析
              </div>
            </div>
          </div>
          <div class="chart_box">
            <!-- {{
                getReduceOrAdd(
                  ZykTeacherUser.secondTotal - ZykTeacherUser.firstTotal
                )
              }} -->
            <p>
              {{ nowYear }}{{ detailYearWord }}国家级资源库教师新增共{{
                getUtils_Fun(ZykTeacherUser.secondTotal)
              }}人，较{{ nowYear - 1 }}{{ detailYearWord }}{{
              getReduceOrAdd(
              ZykTeacherUser.secondTotal - ZykTeacherUser.firstTotal
              )
              }}人。
            </p>
            <div class="echarts-box">
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'visitsMonthChart'"
                  :datas="ZykTeacherUser.dataList"
                  :transverseData="ZykTeacherUser.secondTimeTeacherDay"
                  :colorList="colorList"
                  :innerText="'单位：人'"
                  :isaverage="true"
                  :legendList="[nowYear, (nowYear - 1).toString()]"
                ></discountChart>
              </div>
              <div class="chart_name">
                图43 {{ nowYear }}{{ detailYearWord }}教师新增情况与{{
                  nowYear - 1
                }}年同期对比分析
              </div>
            </div>
          </div>
          <div class="chart_box">
            <!-- {{
                getReduceOrAdd(countryZyk.secondTotal - countryZyk.firstTotal)
              }} -->
            <p>
              {{ nowYear }}{{ detailYearWord }}国家级资源库社会学习者新增共{{
                getUtils_Fun(countryZyk.secondTotal)
              }}人，较{{ nowYear - 1 }}{{ detailYearWord }}{{
              getReduceOrAdd(countryZyk.secondTotal - countryZyk.firstTotal)
              }}人。
            </p>
            <div class="echarts-box">
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'visitsMonthChart'"
                  :datas="countryZyk.dataList"
                  :transverseData="countryZyk.secondTimeSocietyDay"
                  :colorList="colorList"
                  :innerText="'单位：人'"
                  :isaverage="true"
                  :legendList="[nowYear, (nowYear - 1).toString()]"
                ></discountChart>
              </div>
              <div class="chart_name">
                图44 {{ nowYear }}{{ detailYearWord }}社会学习者新增情况与{{
                  nowYear - 1
                }}年同期对比分析
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二十四页 -->
      <div class="chart_box page-box">
        <!-- {{
            getReduceOrAdd(
              ZykEnterpriseUser.secondTotal - ZykEnterpriseUser.firstTotal
            )
          }} -->
        <p>
          {{ nowYear }}{{ detailYearWord }}国家级资源库企业用户新增共{{
            getUtils_Fun(ZykEnterpriseUser.secondTotal)
          }}人，较{{ nowYear - 1 }}{{ detailYearWord }}{{
          getReduceOrAdd(
          ZykEnterpriseUser.secondTotal - ZykEnterpriseUser.firstTotal
          )
          }}人。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ZykEnterpriseUser.dataList"
              :transverseData="ZykEnterpriseUser.secondTimeEnterpriseDay"
              :colorList="colorList"
              :innerText="'单位：人'"
              :legendList="[nowYear, (nowYear - 1).toString()]"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图45 {{ nowYear }}{{ detailYearWord }}企业用户新增情况与{{
              nowYear - 1
            }}年同期对比分析
          </div>
        </div>
        <h6 style="margin-top: 150px">2.1.6.2 资源新增情况</h6>
        <!-- {{
            getReduceOrAdd(
              ZykResourceNewAddCase.secondTotal -
                ZykResourceNewAddCase.firstTotal
            )
          }} -->
        <p>
          {{ nowYear }}{{ detailYearWord }}国家级资源库素材资源新增共{{
            getUtils_Fun(ZykResourceNewAddCase.secondTotal)
          }}条，较{{ nowYear - 1 }}{{ detailYearWord }}{{
          getReduceOrAdd(
          ZykResourceNewAddCase.secondTotal -
          ZykResourceNewAddCase.firstTotal
          )
          }}条。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'typeDistributionChart'"
              :isShowTextColor="true"
              :datas="ZykResourceNewAddCase.resourceDistribution"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :showValue="true"
              :unit="'条'"
              :legendBackgroundColor="true"
              :legendLeft="'55%'"
              :circleSize="80"
            ></circularChart>
          </div>
          <div class="chart_name">
            图46 {{ nowYear
            }}{{ detailYearWord }}国家级资源库新增资源类型分布情况
          </div>
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ZykResourceNewAddCase.dataList"
              :transverseData="ZykResourceNewAddCase.secondTimeResourceDay"
              :colorList="colorList"
              :legendList="[nowYear, (nowYear - 1).toString()]"
              :innerText="'单位：条'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图47 {{ nowYear }}{{ detailYearWord }}素材资源新增情况与{{
              nowYear - 1
            }}年同期对比分析
          </div>
        </div>
      </div>

      <!-- 第二十五页 -->
      <div class="chart_box page-box">
        <h6>2.1.6.3 课程新增情况</h6>
        <!-- {{
            getReduceOrAdd(
              ZykCourseNewAddCase.secondTotal - ZykCourseNewAddCase.firstTotal
            )
          }} -->
        <p>
          {{ nowYear }}{{ detailYearWord }}国家级资源库课程新增共{{
            ZykCourseNewAddCase.secondTotal
          }}门，标准化课程新增{{ ZykCourseNewAddCase.sNum }}门，个性化课程新增{{
            ZykCourseNewAddCase.pNum
          }}门，较{{ nowYear - 1 }}{{ detailYearWord }}{{
          getReduceOrAdd(
          ZykCourseNewAddCase.secondTotal - ZykCourseNewAddCase.firstTotal
          )
          }}门。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ZykCourseNewAddCase.dataList"
              :transverseData="ZykCourseNewAddCase.secondTimeCourseDay"
              :colorList="colorList"
              :legendList="[nowYear, (nowYear - 1).toString()]"
              :innerText="'单位：门'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图48 {{ nowYear }}{{ detailYearWord }}课程新增情况与{{
              nowYear - 1
            }}年同期对比分析
          </div>
        </div>
        <h6 class="m-top150">
          2.1.6.4 国家级资源库{{ nowYear }}{{ detailYearWord }}用户访问情况
        </h6>
        <p>
          {{ nowYear }}{{ detailYearWord }}国家级资源库累计登录用户{{
            getUtils_Fun(ZykStudentUserVisitCase.totalLoginUserNum)
          }}人，累计访问{{
            getUtils_Fun(countryZykTotalVisit)
          }}次。各类型用户日访问趋势如下图所示：
        </p>
        <!-- {{
            getReduceOrAdd(
              ZykStudentUserVisitCase.secondTotal -
                ZykStudentUserVisitCase.firstTotal
            )
          }} -->
        <p>
          学生用户{{ nowYear }}{{ detailYearWord }}访问资源库共{{
            getUtils_Fun(ZykStudentUserVisitCase.secondTotal)
          }}次，较{{ nowYear - 1 }}{{ detailYearWord
          }}{{
          getReduceOrAdd(
          ZykStudentUserVisitCase.secondTotal -
          ZykStudentUserVisitCase.firstTotal
          )
          }}次。
        </p>
        <div class="echarts-box">
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'visitsMonthChart'"
              :datas="ZykStudentUserVisitCase.dataList"
              :transverseData="ZykStudentUserVisitCase.secondTimeStudentDay"
              :colorList="colorList"
              :legendList="[nowYear, (nowYear - 1).toString()]"
              :innerText="'单位：次'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">
            图49 学生用户{{ nowYear }}{{ detailYearWord }}访问情况与{{
              nowYear - 1
            }}年同期对比分析
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import distributionChart from "@/components/chart/distributionChart.vue"; // 地图

export default {
  components: {
    circularChart,
    tcolumnarChart,
    discountChart,
    distributionChart,
  },
  data() {
    return {
      completeMathodNum: 0, //统计接口数量
      platformNum: {}, //平台数
      twoGetCountry: {}, //2.1 203个国家级资源库建设及应用情况分析
      dataAll: {}, //1. 国家职业教育智慧教育平台专业与课程服务中心监测总体分析
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#04F995",
        "#E8FF6C",
        "#00EEF2",
        "#0DA1FD",
        "#F50512",
      ], // 柱状图或折线图的颜色
      mapcolorList: ["#ffd9d9"],
      header: {
        zykName: "",
        zykNum: "",
      },
      loading: "", // 是否导出加载中
      startDay: "",
      endDay: "",
      laststartDay: "", //去年开始时间
      lastendDay: "", //去年结束时间
      // 现在的时间
      nowMonth: null,
      nowDay: "",
      nowYear: null,
      detailYearWord: "", //当前具体时间描述
      reportType: null, //当前报告类型
      // 1.1.1 用户建设及应用情况图1
      userTypeHand: {
        dataList: [],
        studentNum: 0,
        teacherNum: 0,
        total: 0,
      },
      // 1.1.1 用户建设及应用情况图2
      userTalk: {
        dataList: [],
        legendList: ["教师", "学生"],
        transverse: [],
        teacherTotal: null,
        studentTotal: null,
      },
      // 2.1.1 用户建设及应用情况
      userTypeList: {
        dataList: [],
        legendList: [],
        studentNum: {},
        teacherNum: {},
        companyNum: {},
        socialNum: {},
        total: 0,
      },
      // 1.1.2 课程来源分布
      courseTypeNum: {
        dataList: [],
        joinSchool: {},
        joinComp: {},
        total: 0,
        maxArr: {},
      },
      // 1.1.2 课程被访问趋势
      courseTalk: {
        dataList: [],
        transverseData: [],
        legendList: [],
        total: 0,
      },
      // 1.1.2课程被访问量排名
      courseTalkTable: {
        dataList: [],
        MaxArr: {},
        courseVisitNum: 0,
      },
      // 1.1.3 资源建设及应用情况 / 2.1.3 资源建设及应用情况
      educationLevel: {
        visitMaxResource: {},
        dataList: [],
        transverseData: [],
        video: {},
        xuni: {},
        Max: {},
        total: 0,
      },
      buildAndAppAnalysis: {}, //2.1.3 资源整体情况
      // 1.1.3 资源被访问量排名
      resourceTable: {
        dataList: [],
        Max: "",
      },
      // 1.2.1 各省注册用户数排名
      getUser: {
        dataList: [],
        legendList: [],
        MaxArr: {},
        userTotal: null,
      },
      // 1.2.1 各省活跃用户数排名
      provinceStudy: {
        dataList: [],
        legendList: [],
        MaxArr: {},
        total: null,
      },
      // 1.2.1 各省交流互动量排名
      provinceTalking: {
        dataList: [],
        legendList: [],
        MaxArr: {},
        total: null,
      },
      // 1.2.2 各省建设课程数量排名
      curriculum: {
        dataList: [],
        legendList: [],
        MaxArr: {},
        courseObj: {
          name: [],
          value: [],
        },
        totalCourse: null,
        provinceCourse: null,
      },
      // 1.2.2 各省参与建设教师数排名
      teacherProvince: {
        dataList: [],
        legendList: [],
      },
      // 1.2.3 各省建设资源数排名
      sourceMater: {
        dataList: [],
        legendList: [],
        MaxArr: {},
        resourceTotalCount: null,
      },
      // 1.2.3 各省访问资源数排名
      visitProvince: {
        dataList: [],
        legendList: [],
        sortMax: [],
        MaxArr: {},
        total: null,
      },
      // 1.3.1 注册用户趋势
      userAdd: {
        dataList1: [],
        dataList2: [],
        sAtdatas: [],
        Stotal: null,
        Ttotal: null,
        sAtlegendList: ["学生", "教师"],
        legendList: ["学生", "教师", "社会学习者", "企业用户"],
        transverse: [],
        total: null,
      },
      // 1.3.1 用户访问趋势
      userTimeTalk: {
        dataList: [],
        transverse: [],
        total: null,
      },
      // 1.3.2 新增课程
      courseNew: {
        dataList: [],
        transverse: [],
        total: null,
      },
      // 1.3.2 课程被访问趋势
      courseTrend: {
        dataList: [],
        transverse: [],
        total: null,
      },
      // 1.3.3 新增资源
      resourceNew: {
        dataList: [],
        transverse: [],
        total: null,
      },
      // 1.3.3 资源被访问趋势
      resourceVisits: {
        dataList: [],
        transverse: [],
        total: null,
      },
      // 2.1.1 用户总体
      talkAll: {
        resource: null,
        course: null,
        user: null,
      },
      // 2.1.1 学生类型整体情况
      studentConstruction: {
        dataList: [],
        total: 0,
      },
      // 2.1.2 课程建设及应用情况
      getcourse: {
        courseMaxCount: {},
        dataList: [],
        individualization: {},
        Standardization: {},
        transverseData: [],
        total: null,
      },
      // 2.1.4.1 专业大类总体分析情况
      getmajor: {
        dataList: [],
        MaxArr: {},
        Second: {},
        total: null,
      },
      // 2.1.5.1 各省国家级资源库建设及应用情况概览
      getzykTable: {
        dataList: [],
      },
      zykTableAmount: {
        zykCount: 0,
        resourceCount: 0,
        courseCount: 0,
        userCount: 0,
        totalActiveTeacherNum: 0,
        totalActiveStudentNum: 0,
        logNum: 0,
      },
      // 2.2.1.各省用户建设及应用
      userProvince: {
        mapdatas: [],
      },
      // 2.1.5.2.各省国家级资源库用户建设及应用情况
      countryLevelUserProvince: {
        dataList: [],
        userTotal: 0,
        maxUserProvinceInfo: {},
        formunInfo: {},
        activeUserInfo: {},
      },
      // 2.1.5.3 各省国家级资源库课程建设及应用情况
      countryCourseCountProvinceRank_obj: {
        zykCourseMaxProvince: {},
        countryCourseStandardCountMax: {},
        countryCoursePersonalityCountMax: {},
        countryCourseCountProvinceRank: [],
      },
      //2.1.5.4 各省国家级资源库资源建设及应用情况
      getCountryProvinceZykBuild: {
        zykNumMaxProvince: {},
        countryResourceProvinceStateRank: [],
      },
      analysis: {},
      ProfessionAnalysis: {
        top1Data: {
          userTypeCount: {},
          totalVisit: 0,
          totalUser: 0,
          activeStudentNum: 0,
          activeTeacherNum: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
        },
        top1List: [],
        top2Data: {
          userTypeCount: {},
          totalVisit: 0,
          totalUser: 0,
          activeStudentNum: 0,
          activeTeacherNum: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
        },
        top2List: [],
        top3Data: {
          userTypeCount: {},
          totalVisit: 0,
          totalUser: 0,
          activeStudentNum: 0,
          activeTeacherNum: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
        },
        top3List: [],
        top4Data: {
          userTypeCount: {},
          totalVisit: 0,
          totalUser: 0,
          activeStudentNum: 0,
          activeTeacherNum: 0,
          totalResource: 0,
          standardCourse: 0,
          totalCourse: 0,
        },
        top4List: [],
      },
      ProfessionBigClassAnalysisArr: [], //2.1.4.1 专业大类数据分析表
      ProfessionVisitBar: {
        dataList1: {
          dataList1: {},
          dataList2: {},
          dataList3: {},
          dataList4: {},
        },
        dataList2: {
          dataList1: {},
          dataList2: {},
          dataList3: {},
          dataList4: {},
        },
        dataList3: {
          dataList1: {},
          dataList2: {},
          dataList3: {},
          dataList4: {},
        },
        dataList4: {
          dataList1: {},
          dataList2: {},
          dataList3: {},
          dataList4: {},
        },
      },
      ZykStudentUser: {}, //2.1.6.1 用户新增情况-学生用户
      ZykTeacherUser: {}, //2.1.6.1 用户新增情况-教师用户
      countryZyk: {}, //2.1.6.1 用户新增情况-社会学习者
      ZykEnterpriseUser: {}, //2.1.6.1 用户新增情况-企业用户
      ZykResourceNewAddCase: {}, //2.1.6.2 资源新增情况
      ZykCourseNewAddCase: {}, //2.1.6.3 课程新增情况
      countryZykTotalVisit: 0, //2.1.6.4 累计点击数
      ZykStudentUserVisitCase: {}, //2.1.6.4 国家级资源库用户访问情况-学生用户
    };
  },
  watch: {
    completeMathodNum(val) {
      console.log(val);
    },
  },
  mounted() {
    if (this.$route.query) {
      const { token } = this.$route.query;
      this.startDay = this.$route.query.startDay;
      this.endDay = this.$route.query.endDay;
      this.nowYear = this.$route.query.endDay.slice(0, 4);
      this.laststartDay = this.startDay.replaceAll(
        this.nowYear,
        this.nowYear - 1
      );
      this.lastendDay = this.endDay.replaceAll(this.nowYear, this.nowYear - 1);
      sessionStorage.setItem("lrmv2token", token);
      const { zykid } = this.$route.query;
      sessionStorage.setItem("zykId", zykid);
      this.reportType = this.$route.query.type;
      if (this.reportType == 1) this.detailYearWord = "年";
      else if (this.reportType == 2) this.detailYearWord = "年上半年";
    }
    this.nowDate(); //   获取当前时间日期
    this.getPlatFormNumByType_fn(); // 获取平台数
    this.dataAllHandler(); //  1. 国家职业教育智慧教育平台专业与课程服务中心监测总体分析
    this.userTypeHandler(); // 1.1.1 用户建设及应用情况
    this.courseNum(); //  課程數量
    this.resourcesProportion(); //  各类型资源占比
    // 各省用户建设及应用
    this.getProvinceUserBuildApply_Fun();
    // 各省课程建设及应用情况
    this.getProvinceCourseBuildApply_Fun();
    // 1.2.3 各省资源建设及应用
    this.getProvinceResourceBuildApply_Fun();

    // 1.3.1 用户运行分析
    this.getUserRunAnalysis_Fun();
    // 1.3.2 课程运行分析
    this.getCourseRunAnalysis_Fun();
    // 1.3.3 资源运行分析
    this.getResourceRunAnalysis_Fun();

    // 1.2 203个国家级资源库建设与应用分析
    this.getCountryAllZykBuildAndAppAnalysis_Fun();
    // 1.2.1 用户建设及应用分析
    this.getCountryUserBuildAndAppAnalysis_Fun();
    // 1.2.2 课程建设及应用分析
    this.getCourseBuildAndAppAnalysis_Fun();
    // 2.1.3 资源建设及应用分析
    this.getResourceBuildAndAppAnalysis_Fun();
    // 2.1.4 按专业大类汇总统计维度分析
    this.getMajorCountAnalysis_Fun();
    // 2.1.4 资源库专业大类建设与应用分析报告表
    this.getAllProfessionAnalysisTable_Fun();
    // 2.1.4 专业大类数据分析表
    this.getProfessionBigClassAnalysis_Fun();
    // // 2.1.4.1~2.1.4.4 资源库专业大类排名前四运行分析报告
    this.getTopFourProfessionAnalysis_Fun();

    // 2.1.5.1 各省国家级资源库建设及应用情况概览
    this.getCountryZykProvinceBuildAndAnalysisOutline_Fun();
    // 2.1.5.2 各省国家级资源库用户建设及应用情况
    this.getCountryZykProvinceUserBuildAndAnalysis_Fun();
    // 2.1.5.3 各省国家级资源库课程建设及应用情况
    this.getCountryZykProvinceCourseBuildAndAnalysisCase_Fun();
    // 2.1.5.4 各省国家级资源库资源建设及应用情况
    this.getCountryProvinceZykBuildAndAnalysisCase_Fun();

    this.getCountryZykStudentUserNewAddCase_Fun(); // 2.1.6.1 用户新增情况-学生用户
    this.getCountryZykTeacherUserNewAddCase_Fun(); // 2.1.6.1 用户新增情况-教师用户
    this.getCountryZykEnterpriseUserNewAddCase_Fun(); // 2.1.6.1 用户新增情况-企业用户
    this.countryZykSocietyUserNewAddCase_Fun(); // 2.1.6.1 用户新增情况-社会学习者

    this.getCountryZykResourceNewAddCase_Fun(); // 2.1.6.2 资源新增情况

    this.getCountryZykCourseNewAddCase_Fun(); // 2.1.6.3 课程新增情况

    this.getCountryZykVisitCaseTotalByType(); //2.1.6.4 获取累计点击数
    this.getCountryZykStudentUserVisitCase_Fun(); // 2.1.6.4 国家级资源库用户访问情况-学生用户
  },

  methods: {
    changeCity(val) {
      val = val.replace("省", "").replace("市", "");
      if (
        val === "北京" ||
        val === "重庆" ||
        val === "天津" ||
        val === "上海"
      ) {
        return val + "市";
      } else return val + "省";
    },
    getReduceOrAdd(num) {
      const data =
        num > 0
          ? "增加" + this.getUtils_Fun(num)
          : "减少" + this.getUtils_Fun(Math.abs(num));
      return data;
    },
    getUtils_Fun(num) {
      const data =
        num > 100000000
          ? `${(num / 100000000).toFixed(2)}亿`
          : num > 10000
          ? `${(num / 10000).toFixed(2)}万`
          : num;
      return data;
    },
    formatValue(num) {
      return num.toFixed(0);
    },
    // 1.2.1 各省用户建设及应用情况
    getProvinceUserBuildApply_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceUserBuildApply, {
          loading: false,
        })
        .then((res) => {
          this.getUser.userTotal = res.data.userTotal; // 注册用户总计
          this.getUser.dataList = res.data.studyUserNumRank.value;
          this.getUser.legendList = res.data.studyUserNumRank.name;
          const datas = [];
          for (let i = 0; i < this.getUser.dataList.length; i++) {
            datas.push({
              name: this.getUser.legendList[i],
              value: this.getUser.dataList[i],
            });
          }
          // 数组排序
          function Sort(a, b) {
            return b.value - a.value;
          }
          datas.sort(Sort);
          this.getUser.sortMax = datas;
          this.getUser.MaxArr = this.getUser.sortMax[0];

          this.provinceStudy.dataList = res.data.userRankInfo.value;
          this.provinceStudy.legendList = res.data.userRankInfo.name;
          const datas1 = [];
          for (let i = 0; i < this.provinceStudy.dataList.length; i++) {
            this.provinceStudy.total += this.provinceStudy.dataList[i];
            datas1.push({
              name: this.provinceStudy.legendList[i],
              value: this.provinceStudy.dataList[i],
            });
          }
          // 数组排序
          function Sort1(a, b) {
            return b.value - a.value;
          }
          datas1.sort(Sort1);
          this.provinceStudy.sortMax = datas1;
          this.provinceStudy.MaxArr = this.provinceStudy.sortMax[0];

          this.provinceTalking.dataList = res.data.InteractionRankInfo.value;
          this.provinceTalking.legendList = res.data.InteractionRankInfo.name;
          const datas2 = [];
          for (let i = 0; i < this.provinceTalking.dataList.length; i++) {
            this.provinceTalking.total += this.provinceTalking.dataList[i];
            datas2.push({
              name: this.provinceTalking.legendList[i],
              value: this.provinceTalking.dataList[i],
            });
          }
          // 数组排序
          function Sort(a, b) {
            return b.value - a.value;
          }
          datas2.sort(Sort);
          this.provinceTalking.sortMax = datas2;
          this.provinceTalking.MaxArr = this.provinceTalking.sortMax[0];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 1.2.2 各省课程建设及应用情况
    getProvinceCourseBuildApply_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceCourseBuildApply, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.curriculum.totalCourse = res.data.totalCourse;
            this.curriculum.dataList = res.data.courseProvinceRanking.dataList;
            this.curriculum.legendList =
              res.data.courseProvinceRanking.transverseData;
            const datas = [];
            for (let i = 0; i < this.curriculum.dataList.length; i++) {
              datas.push({
                name: this.curriculum.legendList[i],
                value: this.curriculum.dataList[i],
              });
            }
            this.curriculum.courseObj = res.data.reportProvinceCourseRank;
            this.curriculum.provinceCourse = 0;
            for (let i = 0; i < this.curriculum.courseObj.value.length; i++) {
              this.curriculum.provinceCourse +=
                this.curriculum.courseObj.value[i];
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas.sort(Sort);
            this.curriculum.sortMax = datas;
            this.curriculum.MaxArr = this.curriculum.sortMax[0];

            this.teacherProvince.dataList =
              res.data.provinceTeacherBuildRanking.value;
            this.teacherProvince.legendList =
              res.data.provinceTeacherBuildRanking.name;
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 1.2.3 各省资源建设及应用
    getProvinceResourceBuildApply_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceResourceBuildApply, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.sourceMater.resourceTotalCount = res.data.resourceTotalCount;
            for (let i = 0; i < res.data.resourceRanking.length; i++) {
              this.sourceMater.legendList.push(
                res.data.resourceRanking[i].province
              );
              this.sourceMater.dataList.push(res.data.resourceRanking[i].num);
            }
            // 数组排序
            function Sort1(a, b) {
              return b.num - a.num;
            }
            res.data.resourceRanking.sort(Sort1);
            this.sourceMater.sortMax = res.data.resourceRanking;
            this.sourceMater.MaxArr = this.sourceMater.sortMax[0];

            this.visitProvince.dataList =
              res.data.provinceVisitResourceRank.value;
            this.visitProvince.legendList =
              res.data.provinceVisitResourceRank.name;

            const datas1 = [];
            for (let i = 0; i < this.visitProvince.dataList.length; i++) {
              this.visitProvince.total += this.visitProvince.dataList[i];
              datas1.push({
                name: this.visitProvince.legendList[i],
                value: this.visitProvince.dataList[i],
              });
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas1.sort(Sort);
            this.visitProvince.sortMax = datas1;
            this.visitProvince.MaxArr = this.visitProvince.sortMax[0];
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 1.3.1 用户运行分析
    getUserRunAnalysis_Fun() {
      this.$axios
        .post(
          this.$apiurls.getUserRunAnalysis,
          { endDay: this.endDay, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          //  图13
          this.userAdd.transverse =
            res.data.countryReportUserMonthNew.enterprise.name;
          this.userAdd.dataList1.push(
            res.data.countryReportUserMonthNew.student.value,
            res.data.countryReportUserMonthNew.teacher.value
          );
          this.userAdd.dataList2.push(
            res.data.countryReportUserMonthNew.enterprise.value,
            res.data.countryReportUserMonthNew.social.value
          );
          this.userAdd.tran = [];
          this.userAdd.tran.push("社会学习者", "企业用户");
          const studentV = this.userAdd.dataList1[0];
          const teacherV = this.userAdd.dataList1[1];
          // 图 31
          this.userAdd.sAtdatas.push(studentV, teacherV);
          const enterpriseV = this.userAdd.dataList2[0];
          const socialV = this.userAdd.dataList2[1];

          let totalE = 0;
          let totalV = 0;

          studentV.forEach((item) => {
            this.userAdd.Stotal += item;
          });
          teacherV.forEach((item) => {
            this.userAdd.Ttotal += item;
          });

          enterpriseV.forEach((item) => {
            totalE += item;
          });

          socialV.forEach((item) => {
            totalV += item;
          });
          this.userAdd.total =
            this.userAdd.Stotal + this.userAdd.Ttotal + totalE + totalV;

          this.userTimeTalk.dataList =
            res.data.countryReportUserMonthVisits.value;
          this.userTimeTalk.dataList.forEach((item) => {
            this.userTimeTalk.total += item;
          });
          this.userTimeTalk.transverse =
            res.data.countryReportUserMonthVisits.name;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 1.3.2 课程运行分析
    getCourseRunAnalysis_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCourseRunAnalysis,
          { endDay: this.endDay, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            // 新增课程
            this.courseNew.dataList = res.data.courseNew.value;
            this.courseNew.transverse = res.data.courseNew.name;
            this.courseNew.dataList.forEach((item) => {
              this.courseNew.total += item;
            });
            // 课程被访问趋势
            this.courseTrend.dataList = res.data.courseVisits.value;
            this.courseTrend.transverse = res.data.courseVisits.name;
            this.courseTrend.dataList.forEach((item) => {
              this.courseTrend.total += item;
            });
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 1.3.3 资源运行分析
    getResourceRunAnalysis_Fun() {
      this.$axios
        .post(
          this.$apiurls.getResourceRunAnalysis,
          { endDay: this.endDay, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            //  新增资源
            this.resourceNew.dataList = res.data.resourceNew.value;
            this.resourceNew.transverse = res.data.resourceNew.name;
            this.resourceNew.dataList.forEach((item) => {
              this.resourceNew.total += item;
            });
            // 资源被访问趋势
            this.resourceVisits.dataList = res.data.resourceVisits.value;
            this.resourceVisits.transverse = res.data.resourceVisits.name;
            this.resourceVisits.dataList.forEach((item) => {
              this.resourceVisits.total += item;
            });
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1 203个国家级资源库建设及应用情况分析
    getCountryAllZykBuildAndAppAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryAllZykBuildAndAppAnalysis, {
          loading: false,
        })
        .then((res) => {
          const {
            companyBuild,
            resourceNum,
            schoolBuild,
            standardNum,
            totalZykVisitNum,
            zykCountryNum,
            zykUserNum,
            platform,
            countryProfessionClass
          } = res.data;
          this.twoGetCountry = {
            companyBuild,
            resourceNum,
            schoolBuild,
            standardNum,
            totalZykVisitNum,
            zykCountryNum,
            zykUserNum,
            platform,
            countryProfessionClass
          };
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.1 用户建设及应用分析
    getCountryUserBuildAndAppAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryUserBuildAndAppAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.talkAll.resource = res.data.resourceCountVisitNum;
          this.talkAll.course = res.data.courseCountVisitNum;
          this.talkAll.user = res.data.userCountCommNum;
          // this.userTypeList.total = res.data.userNum;
          this.userTypeList.total = 0;
          let datas = [];
          for (
            let i = 0;
            i < res.data.userProfileMap.userProfileNum.length;
            i++
          ) {
            datas.push({
              name: res.data.userProfileMap.userProfileName[i],
              value: res.data.userProfileMap.userProfileNum[i],
            });
            this.userTypeList.total +=
              res.data.userProfileMap.userProfileNum[i];
          }
          this.userTypeList.dataList = datas;
          // 教师数量
          this.userTypeList.tearchNum = datas.find(
            (item) => item.name == "教师"
          );
          // 学生数
          // this.userTypeList.studentNum = datas.find(
          //   (item) => item.name == "学生"
          // );
          // 企业用户
          this.userTypeList.companyNum = datas.find(
            (item) => item.name == "企业用户"
          );
          // 社会学习者
          this.userTypeList.socialNum = datas.find(
            (item) => item.name == "社会学习者"
          );
          this.userTypeList.legendList =
            res.data.userProfileMap.userProfileName;
          this.userTypeList.studentNum.value = 0;
          this.studentConstruction.dataList = res.data.studentType.map(
            (item) => {
              this.userTypeList.studentNum.value += Number(item.value);
              const { name } = item;
              const { value } = item;
              return {
                name,
                value,
              };
            }
          );
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.2 课程建设及应用分析
    getCourseBuildAndAppAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getCourseBuildAndAppAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.getcourse.courseNum = res.data.courseCountNum;
          this.getcourse.CourseDayVisitNum = res.data.CourseDayVisitNum;
          this.getcourse.courseMaxCount = res.data.courseMaxCount;
          this.getcourse.dataList = res.data.courseType.value;
          this.getcourse.total =
            this.getcourse.dataList[0] + this.getcourse.dataList[1];
          this.getcourse.transverseData = res.data.courseType.name;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.3 资源建设及应用分析
    getResourceBuildAndAppAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getResourceBuildAndAppAnalysis, {
          loading: false,
        })
        .then((res) => {
          const {
            resourceCapacityNum,
            resourceNum,
            resourceTotal,
            visitMaxResource,
          } = res.data;
          this.buildAndAppAnalysis = res.data.resourceTypeMap;
          this.buildAndAppAnalysis.maxArr = {
            name: res.data.resourceTypeMap.name[0],
            value: res.data.resourceTypeMap.value[0],
          };
          this.buildAndAppAnalysis.resourceCapacityNum = resourceCapacityNum;
          this.buildAndAppAnalysis.resourceNum = resourceNum;
          this.buildAndAppAnalysis.resourceTotal = resourceTotal;
          visitMaxResource.name = visitMaxResource.name.split(",")[0];
          if (visitMaxResource.zykName.indexOf("资源库") == -1) {
            visitMaxResource.zykName += "资源库";
          }
          this.buildAndAppAnalysis.visitMaxResource = visitMaxResource;
          let arr = [];
          for (let i = 0; i < res.data.resourceTypeMap.name.length; i++) {
            arr.push({
              name: res.data.resourceTypeMap.name[i],
              value: res.data.resourceTypeMap.value[i],
            });
          }
          this.buildAndAppAnalysis.xuni = arr.find(
            (item) => item.name == "虚拟仿真"
          );
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.4 按专业大类汇总统计维度分析
    getMajorCountAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getMajorCountAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.getmajor.professionData = res.data.professionData;
          function Sort(a, b) {
            return b.value - a.value;
          }
          const data = res.data.professionDataList.sort(Sort);
          this.getmajor.dataList = data;
          this.getmajor.MaxArr = data[0];
          this.getmajor.Second = data[1];
          data.forEach((item) => {
            this.getmajor.total += item.value;
          });
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.4 资源库专业大类建设与应用分析报告表
    getAllProfessionAnalysisTable_Fun() {
      this.$axios
        .post(this.$apiurls.getAllProfessionAnalysisTable, {
          loading: false,
        })
        .then((res) => {
          let data = res.data.data;
          for (let i = 0; i < data.length; i++) {
            data[i].number = i + 1;
          }
          this.AllProfessionAnalysisArr1 = data.slice(0, 15);
          this.AllProfessionAnalysisArr2 = data.slice(15, 40);
          this.AllProfessionAnalysisArr3 = data.slice(40, 65);
          this.AllProfessionAnalysisArr4 = data.slice(65, 90);
          this.AllProfessionAnalysisArr5 = data.slice(90, 117);
          this.AllProfessionAnalysisArr6 = data.slice(117, 142);
          this.AllProfessionAnalysisArr7 = data.slice(142, 166);
          this.AllProfessionAnalysisArr8 = data.slice(166, 192);
          this.AllProfessionAnalysisArr9 = data.slice(192);
        });
    },

    // 2.1.4 专业大类数据分析表
    getProfessionBigClassAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getProfessionBigClassAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.ProfessionBigClassAnalysisArr = res.data;
        });
    },

    // 2.1.4.1~2.1.4.4 资源库专业大类排名前四运行分析报告
    getTopFourProfessionAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getTopFourProfessionAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.ProfessionAnalysis = res.data;
          this.bigClass1 = res.data.top1Data.bigClass;
          this.bigClass2 = res.data.top2Data.bigClass;
          this.bigClass3 = res.data.top3Data.bigClass;
          this.bigClass4 = res.data.top4Data.bigClass;

          let top1Obj = { topList: res.data.top1List };
          let top2Obj = { topList: res.data.top2List };
          let top3Obj = { topList: res.data.top3List };
          let top4Obj = { topList: res.data.top4List };
          let topArr = [top1Obj, top2Obj, top3Obj, top4Obj];

          for (let i = 0; i < topArr.length; i++) {
            let totalVisit = 0;
            let totalUser = 0;
            let activeStudentNum = 0;
            let activeTeacherNum = 0;
            let totalResource = 0;
            let standardCourse = 0;
            let totalCourse = 0;
            topArr[i]["topList"].forEach((item) => {
              totalVisit += Number(item.totalVisit);
              totalUser += Number(item.totalUser);
              activeStudentNum += Number(item.activeStudentNum);
              activeTeacherNum += Number(item.activeTeacherNum);
              totalResource += Number(item.totalResource);
              standardCourse += Number(item.standardCourse);
              totalCourse += Number(item.totalCourse);
            });
            this.ProfessionAnalysis[`top${i + 1}Data`]["totalVisit"] =
              totalVisit;
            this.ProfessionAnalysis[`top${i + 1}Data`]["totalUser"] = totalUser;
            this.ProfessionAnalysis[`top${i + 1}Data`]["activeStudentNum"] =
              activeStudentNum;
            this.ProfessionAnalysis[`top${i + 1}Data`]["activeTeacherNum"] =
              activeTeacherNum;
            this.ProfessionAnalysis[`top${i + 1}Data`]["totalResource"] =
              totalResource;
            this.ProfessionAnalysis[`top${i + 1}Data`]["standardCourse"] =
              standardCourse;
            this.ProfessionAnalysis[`top${i + 1}Data`]["totalCourse"] =
              totalCourse;
          }
          this.getTopFourProfessionVisitBar_Fun(2, res.data.top1Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(1, res.data.top1Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(4, res.data.top1Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(3, res.data.top1Data.bigClass);

          this.getTopFourProfessionVisitBar_Fun(2, res.data.top2Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(1, res.data.top2Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(4, res.data.top2Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(3, res.data.top2Data.bigClass);

          this.getTopFourProfessionVisitBar_Fun(2, res.data.top3Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(1, res.data.top3Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(4, res.data.top3Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(3, res.data.top3Data.bigClass);

          this.getTopFourProfessionVisitBar_Fun(2, res.data.top4Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(1, res.data.top4Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(4, res.data.top4Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(3, res.data.top4Data.bigClass);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    getTopFourProfessionVisitBar_Fun(type, professionBigClass) {
      this.$axios
        .post(
          this.$apiurls.getTopFourProfessionVisitBar,
          { type, professionBigClass },
          {
            loading: false,
          }
        )
        .then((res) => {
          switch (professionBigClass) {
            case this.bigClass1:
              if (type == 2) {
                this.ProfessionVisitBar.dataList1.dataList1 = res.data;
              } else if (type == 1) {
                this.ProfessionVisitBar.dataList1.dataList2 = res.data;
              } else if (type == 4) {
                this.ProfessionVisitBar.dataList1.dataList3 = res.data;
              } else {
                this.ProfessionVisitBar.dataList1.dataList4 = res.data;
              }

              break;
            case this.bigClass2:
              if (type == 2) {
                this.ProfessionVisitBar.dataList2.dataList1 = res.data;
              } else if (type == 1) {
                this.ProfessionVisitBar.dataList2.dataList2 = res.data;
              } else if (type == 4) {
                this.ProfessionVisitBar.dataList2.dataList3 = res.data;
              } else {
                this.ProfessionVisitBar.dataList2.dataList4 = res.data;
              }
              break;
            case this.bigClass3:
              if (type == 2) {
                this.ProfessionVisitBar.dataList3.dataList1 = res.data;
              } else if (type == 1) {
                this.ProfessionVisitBar.dataList3.dataList2 = res.data;
              } else if (type == 4) {
                this.ProfessionVisitBar.dataList3.dataList3 = res.data;
              } else {
                this.ProfessionVisitBar.dataList3.dataList4 = res.data;
              }
              break;
            case this.bigClass4:
              if (type == 2) {
                this.ProfessionVisitBar.dataList4.dataList1 = res.data;
              } else if (type == 1) {
                this.ProfessionVisitBar.dataList4.dataList2 = res.data;
              } else if (type == 4) {
                this.ProfessionVisitBar.dataList4.dataList3 = res.data;
              } else {
                this.ProfessionVisitBar.dataList4.dataList4 = res.data;
              }
              break;
            default:
              break;
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.5.1 各省国家级资源库建设及应用情况概览
    getCountryZykProvinceBuildAndAnalysisOutline_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryZykProvinceBuildAndAnalysisOutline, {
          loading: false,
        })
        .then((res) => {
          let arr = res.data.CountryZykProvinceBuildAndAnalysis;
          this.getzykTable.dataList = arr;
          for (const item of arr) {
            this.zykTableAmount.zykCount += +item.zykCount;
            this.zykTableAmount.resourceCount += +item.resourceCount;
            this.zykTableAmount.courseCount += +item.courseCount;
            this.zykTableAmount.userCount += +item.userCount;
            this.zykTableAmount.totalActiveTeacherNum +=
              +item.totalActiveTeacherNum;
            this.zykTableAmount.totalActiveStudentNum +=
              +item.totalActiveStudentNum;
            this.zykTableAmount.logNum += +item.logNum;
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.5.2 各省国家级资源库用户建设及应用情况
    getCountryZykProvinceUserBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryZykProvinceUserBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.userProvince.mapdatas = res.data.countryProvinceLogTotal;
          this.countryLevelUserProvince.userTotal = res.data.zykUserNum;
          this.countryLevelUserProvince.dataList =
            res.data.countryProvinceStatusActiveUserRank;
          this.countryLevelUserProvince.maxUserProvinceInfo.province =
            res.data.maxRegisteredCountryUsersProvince.province;
          this.countryLevelUserProvince.maxUserProvinceInfo.maxValue =
            res.data.maxRegisteredCountryUsersProvince.num;
          this.countryLevelUserProvince.formunInfo.total =
            res.data.countryForumLogProvinceNumTotal;
          this.countryLevelUserProvince.formunInfo.maxValue =
            res.data.maxInteractiveUsersProvince.num;
          this.countryLevelUserProvince.formunInfo.province =
            res.data.maxInteractiveUsersProvince.province;
          this.countryLevelUserProvince.activeUserInfo.total =
            res.data.countryProvinceStatusActiveUserTotal;
          this.countryLevelUserProvince.activeUserInfo.maxValue =
            res.data.countryProvinceStatusActiveUserRank[0].activeNum;
          this.countryLevelUserProvince.activeUserInfo.province =
            res.data.countryProvinceStatusActiveUserRank[0].province;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.5.3 各省国家级资源库课程建设及应用情况
    getCountryZykProvinceCourseBuildAndAnalysisCase_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryZykProvinceCourseBuildAndAnalysisCase, {
          loading: false,
        })
        .then((res) => {
          const {
            countryCourseCountProvinceRank,
            countryCoursePersonalityCountMax,
            countryCourseStandardCountMax,
            zykCourseBuildCountNum,
            zykCourseMaxProvince,
            standardNum,
          } = res.data;
          let snum = 0;
          let pnum = 0;
          countryCourseCountProvinceRank.forEach((item) => {
            snum += item.snum;
            pnum += item.pnum;
          });
          this.countryCourseCountProvinceRank_obj = {
            countryCourseCountProvinceRank,
            countryCoursePersonalityCountMax,
            countryCourseStandardCountMax,
            zykCourseBuildCountNum,
            zykCourseMaxProvince,
            snum,
            pnum,
            standardNum,
          };
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.5.4 各省国家级资源库资源建设及应用情况
    getCountryProvinceZykBuildAndAnalysisCase_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryProvinceZykBuildAndAnalysisCase, {
          loading: false,
        })
        .then((res) => {
          const {
            countryResourceProvinceStateRank,
            countryResourceTotalLog,
            resourceVisitMaxProvince,
            zykBuildResourceCount,
            zykNumMaxProvince,
          } = res.data;
          this.getCountryProvinceZykBuild = {
            countryResourceProvinceStateRank,
            countryResourceTotalLog,
            resourceVisitMaxProvince,
            zykBuildResourceCount,
            zykNumMaxProvince,
          };
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.6.1 用户新增情况-学生用户
    getCountryZykStudentUserNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykStudentUserNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykStudentUser = res.data;
          this.ZykStudentUser.firstTotal = res.data.studentFirstTimeNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykStudentUser.secondTotal =
            res.data.studentSecondTimeNum.reduce((a, b) => a + b, 0);
          this.ZykStudentUser.dataList = [
            res.data.studentSecondTimeNum,
            res.data.studentFirstTimeNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.6.1 用户新增情况-教师用户
    getCountryZykTeacherUserNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykTeacherUserNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykTeacherUser = res.data;
          this.ZykTeacherUser.firstTotal = res.data.firstTimeTeacherNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykTeacherUser.secondTotal =
            res.data.secondTimeTeacherNum.reduce((a, b) => a + b, 0);
          this.ZykTeacherUser.dataList = [
            res.data.secondTimeTeacherNum,
            res.data.firstTimeTeacherNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.6.1 用户新增情况-社会学习者
    countryZykSocietyUserNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.countryZykSocietyUserNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.countryZyk = res.data;
          this.countryZyk.firstTotal = res.data.firstTimeSocietyNum.reduce(
            (a, b) => a + b,
            0
          );
          this.countryZyk.secondTotal = res.data.secondTimeSocietyNum.reduce(
            (a, b) => a + b,
            0
          );
          this.countryZyk.dataList = [
            res.data.secondTimeSocietyNum,
            res.data.firstTimeSocietyNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.6.1 用户新增情况-企业用户
    getCountryZykEnterpriseUserNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykEnterpriseUserNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykEnterpriseUser = res.data;
          this.ZykEnterpriseUser.firstTotal =
            res.data.firstTimeEnterpriseNum.reduce((a, b) => a + b, 0);
          this.ZykEnterpriseUser.secondTotal =
            res.data.secondTimeEnterpriseNum.reduce((a, b) => a + b, 0);
          this.ZykEnterpriseUser.dataList = [
            res.data.secondTimeEnterpriseNum,
            res.data.firstTimeEnterpriseNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.6.2 资源新增情况
    getCountryZykResourceNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykResourceNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykResourceNewAddCase = res.data;
          this.ZykResourceNewAddCase.firstTotal =
            res.data.firstTimeResourceNum.reduce((a, b) => a + b, 0);
          this.ZykResourceNewAddCase.secondTotal =
            res.data.secondTimeResourceNum.reduce((a, b) => a + b, 0);
          this.ZykResourceNewAddCase.dataList = [
            res.data.secondTimeResourceNum,
            res.data.firstTimeResourceNum,
          ];
          let data = res.data.secondTimeResourceDistribution;
          this.ZykResourceNewAddCase.resourceDistribution = [
            {
              name: "视频",
              value: data.video,
            },
            {
              name: "图形图像",
              value: data.image,
            },
            {
              name: "文本",
              value: data.text,
            },
            {
              name: "PPT和富媒体",
              value: data.ppt + data.media + data.courseware,
            },
            {
              name: "动画",
              value: data.animation,
            },
            {
              name: "微课",
              value: data.microCourses,
            },
            {
              name: "音频",
              value: data.audio,
            },
            {
              name: "虚拟仿真",
              value: data.simulation,
            },
            {
              name: "其他",
              value: data.other,
            },
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.6.3 课程新增情况
    getCountryZykCourseNewAddCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykCourseNewAddCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykCourseNewAddCase = res.data;
          this.ZykCourseNewAddCase.firstTotal =
            res.data.firstTimeCourseNum.reduce((a, b) => a + b, 0);
          this.ZykCourseNewAddCase.secondTotal =
            res.data.secondTimeCourseNum.reduce((a, b) => a + b, 0);
          this.ZykCourseNewAddCase.dataList = [
            res.data.secondTimeCourseNum,
            res.data.firstTimeCourseNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    //2.1.6.4 获取累计点击数
    getCountryZykVisitCaseTotalByType() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykVisitCaseTotalByType,
          {
            fistStartTime: this.$route.query.startDay,
            fistEndTime: this.$route.query.endDay,
            types: [1, 2, 3, 4],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.countryZykTotalVisit = res.data.totalVisitNum;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.6.4 国家级资源库用户访问情况-学生用户
    getCountryZykStudentUserVisitCase_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykStudentUserVisitCase,
          {
            fistEndTime: this.lastendDay,
            fistStartTime: this.laststartDay,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.ZykStudentUserVisitCase = res.data;
          this.ZykStudentUserVisitCase.firstTotal =
            res.data.firstTimeStudentNum.reduce((a, b) => a + b, 0);
          this.ZykStudentUserVisitCase.secondTotal =
            res.data.secondTimeStudentNum.reduce((a, b) => a + b, 0);
          this.ZykStudentUserVisitCase.dataList = [
            res.data.secondTimeStudentNum,
            res.data.firstTimeStudentNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    getYearRange(year) {
      // 创建传入年份的开始时间
      const yearStart = new Date(year, 0, 1, 0, 0, 0, 0);
      // 创建传入年份的结束时间
      const yearEnd = new Date(year, 11, 31, 23, 59, 59, 999);
      // 格式化开始时间
      const startFormatted = this.formatDate(yearStart);
      // 格式化结束时间
      const endFormatted = this.formatDate(yearEnd);
      return {
        start: startFormatted,
        end: endFormatted,
      };
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = this.padZero(date.getMonth() + 1);
      const day = this.padZero(date.getDate());
      return `${year}-${month}-${day}`;
    },

    padZero(number) {
      return number < 10 ? `0${number}` : number;
    },

    // 截取当前日期的赋值操作
    nowDate() {
      const Frist = this.endDay.indexOf("-") + 1;
      const last = this.endDay.lastIndexOf("-") + 1;
      const regx = /^[0]+/;
      this.nowMonth = this.endDay.slice(Frist, last - 1).replace(regx, "");
      this.nowDay = this.endDay.slice(last, this.endDay.length);
    },

    // 导出月报
    toImage() {
      this.loading = this.$loading({
        lock: true,
        text: "正在导出中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$axios
        .post(
          this.$apiurls.exportMonthReport,
          {
            courseName: "",
            isAll: false,
            month: this.yearAndMonthly,
            reportType: 0,
            zykId: sessionStorage.getItem("zykId"),
            zykName: this.header.zykName,
            zykNum: this.header.zykNum,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            window.open(res.data);
            this.loading.close();
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        })
        .catch(() => {
          this.loading.close();
        });
    },
    // 获取平台数
    getPlatFormNumByType_fn() {
      this.$axios
        .post(this.$apiurls.getPlatFormNumByType, { loading: false })
        .then((res) => {
          if (res.code === 200) {
            this.platformNum = res.data;
          }
        });
    },
    // 1. 国家职业教育智慧教育平台专业与课程服务中心监测总体分析
    dataAllHandler() {
      this.$axios
        .post(this.$apiurls.getOverviewData, {
          loading: false,
        })
        .then((res) => {
          this.dataAll = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 1.1.1 用户建设及应用情况
    userTypeHandler() {
      this.$axios
        .post(this.$apiurls.getUserBuildApply, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.allReportUserForType.value.length; i++) {
            this.userTypeHand.total += res.data.allReportUserForType.value[i];
            this.userTypeHand.dataList.push({
              name: res.data.allReportUserForType.name[i],
              value: res.data.allReportUserForType.value[i],
            });
          }
          // 教师数量
          const tearch = this.userTypeHand.dataList.find(
            (item) => item.name == "教师"
          );
          this.userTypeHand.tearchNum = tearch.value;
          // 学生数
          const student = this.userTypeHand.dataList.find(
            (item) => item.name == "学生"
          );
          this.userTypeHand.studentNum = student.value;
          this.userTypeHand.legendList = res.data.allReportUserForType.name;

          this.userTalk.dataList.push(
            res.data.userMonthVisits.teacher.value,
            res.data.userMonthVisits.student.value
          );
          this.userTalk.transverse = res.data.userMonthVisits.student.name;
          this.userTalk.teacherTotal =
            res.data.userMonthVisits.teacherTotal > 100000000
              ? `${(res.data.userMonthVisits.teacherTotal / 100000000).toFixed(
                  2
                )}亿`
              : `${(res.data.userMonthVisits.teacherTotal / 10000).toFixed(
                  2
                )}万`;
          this.userTalk.studentTotal =
            res.data.userMonthVisits.studentTotal > 100000000
              ? `${(res.data.userMonthVisits.studentTotal / 100000000).toFixed(
                  2
                )}亿`
              : `${(res.data.userMonthVisits.studentTotal / 10000).toFixed(
                  2
                )}万`;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 1.1.2 课程建设及应用情况
    courseNum() {
      this.$axios
        .post(this.$apiurls.getCourseBuildApply, {
          loading: false,
        })
        .then((res) => {
          this.courseTypeNum.dataList.push(
            {
              name: "资源库课程数",
              value: res.data.zykCourseCount,
            },
            {
              name: "在线精品课数",
              value: res.data.onlineCourseNum,
            },
            {
              name: "视频公开课数",
              value: res.data.videoCourseNum,
            }
          );

          this.courseTypeNum.dataList.forEach((item) => {
            this.courseTypeNum.total += item.value;
          });
          // 最大值得数组
          function sortMax(a, b) {
            return b.value - a.value;
          }
          this.courseTypeNum.dataList.sort(sortMax);
          this.courseTypeNum.maxArr = this.courseTypeNum.dataList[0];
          this.courseTalk.dataList =
            res.data.courseYearMonthVisits.course.value;
          this.courseTalk.transverseData =
            res.data.courseYearMonthVisits.course.name;
          this.courseTalk.dataList.forEach((item) => {
            this.courseTalk.total += item;
          });
          this.courseTalkTable.courseVisitNum = res.data.courseVisitNum;
          this.courseTalkTable.dataList = res.data.courseVisitsRank;
          this.courseTalkTable.dataList.forEach((item) => {
            if (item.courseName.length > 8) {
              item.courseName = `${item.courseName.slice(0, 9)}...`;
            }
            this.courseTalkTable.total += item.courseTotalVisit;
          });

          function Sort(a, b) {
            return b.courseTotalVisit - a.courseTotalVisit;
          }
          this.courseTalkTable.dataList.sort(Sort);
          this.courseTalkTable.MaxArr = this.courseTalkTable.dataList[0];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 资源类型占比
    resourcesProportion() {
      this.$axios
        .post(this.$apiurls.getResourceBuildApply, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.resourceTypes.name.length; i++) {
              this.educationLevel.total += res.data.resourceTypes.value[i];
              this.educationLevel.dataList.push({
                name: res.data.resourceTypes.name[i],
                value: res.data.resourceTypes.value[i],
              });
            }

            function Sort(a, b) {
              return a.value - b.value;
            }
            this.educationLevel.dataList.sort(Sort);

            this.educationLevel.Max = this.educationLevel.dataList[0];
            this.educationLevel.totalVisitNum = res.data.totalVisitNum;
            this.educationLevel.resourceCapacityNum =
              res.data.resourceCapacityNum;

            this.educationLevel.video = this.educationLevel.dataList.find(
              (item) => item.name == "视频"
            );
            this.educationLevel.dataList.forEach((item) => {
              this.educationLevel.transverseData.push(item.name);
            });
            this.educationLevel.xuni = this.educationLevel.dataList.find(
              (item) => item.name == "虚拟仿真"
            );

            this.resourceTable.dataList =
              res.data.reportResourceRank.resourceRank;
            function Sort1(a, b) {
              return b.num - a.num;
            }
            this.resourceTable.dataList.sort(Sort1);
            this.resourceTable.Max = this.resourceTable.dataList[0].name;
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0px;
  padding: 0px;
}

.analysisReport {
  position: relative;
  width: 100%;
  background: #fff;

  .analysisReport_box {
    width: 86.7%;
    margin: 0px auto;
    height: 76720px; //28

    .page-box {
      padding: 7% 0;
      height: 2740px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      // border: 1px solid red;
      .m-top150 {
        margin-top: 150px;
      }
      .header_titles {
        display: flex;
        justify-content: center;
        flex-flow: column;
        color: #000;
        text-align: center;
        position: relative;
        font-size: 40px;

        h1 {
          font-size: 55px;
          font-weight: bold;
          color: #1d244e;
        }

        .monthly {
          font-size: 40px;
          font-weight: 400;
          color: #1d244e;
          line-height: 30px;
          margin-top: 6px;
        }
      }

      .number_time {
        margin: 30px 0;

        div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #707f9d;
          font-size: 25px;
        }

        p {
          width: 100%;
          height: 1px;
          background: #707f9d;
          margin-top: 8px;

          &:last-child {
            opacity: 0.5;
            margin-top: 4px;
          }
        }
      }
      // 一级标题
      .division {
        font-weight: bold;
        font-size: 44px;
        color: #1d244e;
        margin: 35px 0;
      }

      h3,
      h4,
      h5,
      h6 {
        font-weight: 700;
        color: #1d244e;
        margin-top: 30px;
        margin-bottom: 35px;
      }

      h3 {
        font-size: 50px;
      }

      h4 {
        font-size: 42px;
      }

      h5 {
        font-size: 40px;
      }

      h6 {
        font-size: 39px;
      }

      p {
        font-weight: 540;
        font-size: 35px;
        text-indent: 2em;
        line-height: 70px;
        color: #272a3f;
      }

      .chart_name {
        font-weight: 540;
        text-align: center;
        font-size: 32px;
        color: #272a3f;
        margin-top: 20px;
      }

      .notes {
        margin: 35px 0;
        line-height: 50px;
        font-size: 30px;
        color: black;
      }

      .biaoge {
        font-weight: 540 !important;
        width: 98%;
        color: #272a3f !important;
        margin: 25px auto;

        .course {
          text-align: center;

          tr {
            height: 45px;
            line-height: 45px;
            color: #707f9d;
            font-size: 22px;

            &:nth-child(2n) {
              background: rgba(11, 201, 212, 0.2);
              color: #566178;
            }

            &:nth-child(2n-1) {
              background: rgba(73, 187, 233);
              color: #566178;
            }
          }

          .th_tr {
            background: rgb(88, 136, 248);
            color: #fff;
          }
        }
      }

      .echartsHeight {
        height: calc(100vw / 1080 * 300);
        margin: 10px auto 0px;
      }
    }

    // 首页样式
    .HomePage {
      padding-left: 10%;

      #image {
        width: 559px;
        height: 70px;
        background: url("../../../../public/pdf_year.png") no-repeat;
        background-size: 100% 100%;
      }

      #PdfTitle {
        padding: 20px 0px 20px 40px;
        border-left: 3px solid #729ac0;

        #FristTitle {
          font-size: 65px;
          font-weight: 700;
          margin-bottom: 40px;
        }

        #SecondTitle {
          font-size: 65px;
          font-weight: 600;
          margin-bottom: 40px;
        }
        .ThrendTitle {
          font-size: 50px;
          font-weight: 600;
          margin-bottom: 40px;
        }
        #FourTitle {
          font-size: 50px;
          font-weight: 700;
          margin-bottom: 40px;
        }
      }

      #foot {
        display: flex;
        .footBox {
          flex-direction: column;
          display: flex;
          align-items: center;
          font-size: 42px;
          margin-left: 4.5%;

          p {
            margin: 20px 0px;
          }
        }
      }
    }

    // 目录样式
    .catalogue {
      padding: 10% 8%;

      .title {
        text-align: center;
        margin-bottom: 4%;
        font-size: 40px;
      }

      h5 {
        margin-top: 50px;
        margin-bottom: 15px;
        line-height: 40px;
        display: flex;
        align-items: center;
        font-size: 45px;

        .dot {
          flex: 1;
          border-top: dotted #1d244e 7px;
          margin: 0 10px;
        }
      }

      .Second_text {
        padding-left: 1.8em;
      }

      .Thred_text {
        padding-left: 7.69em;
      }
    }

    // 弹性盒子
    .flex-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }

  .export {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}
</style>
